<template lang="pug">
  .b2b-page-servicio
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-button(
                v-if='canAdminProject',
                type='neutral',
                icon='ods-icon-arrow-right',
                size='small',
                @click.native='handleGoParties')
                | {{ $t('project_detail.buttons.management_services_parties') }}

      ods-form(
        ref='serviceDetailEditForm',
        :model='serviceDetailEditForm',
        :rules='serviceDetailEditFormRules',
        label-width='14rem',
        label-position='top',
        size='mini',
        status-icon)
        ods-row.info
          ods-col(:span='24')
            p {{ $t('project_detail.info_message') }}
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("project_detail.project_detail_edit_form.name")',
              prop='name')
              ods-input(
                :disabled='!canModifyProject',
                v-model='serviceDetailEditForm.name')
          ods-col(:span='4')
          ods-col(:span='9')
            ods-form-item(
              :label='$t("project_detail.project_detail_edit_form.code")',
              prop='code')
              ods-input(
                :disabled='!canModifyProject',
                v-model='serviceDetailEditForm.code')
          ods-col(:span='1')
            ods-tooltip(:content='$t("buttons.inicialize_tooltip")', placement='bottom')
              ods-button.refresh(
                type='primary',
                icon='ods-icon-refresh',
                size='medium',
                circle,
                @click='inicializecode')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("project_detail.project_detail_edit_form.enable")',
              prop='enable')
              ods-switch(
                :disabled='!canModifyProject',
                :active-color='primaryColor',
                inactive-color='#D5DCE0',
                v-model='serviceDetailEditForm.enable')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("project_detail.project_detail_edit_form.security_code")',
              prop='securityCode')
              ods-input(
                :disabled='true',
                v-model='serviceDetailEditForm.securityCode')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("project_detail.project_detail_edit_form.issuing")',
              prop='isSender')
              ods-switch(
                :disabled='!canModifyProject',
                :active-color='primaryColor',
                @click.native='changeProjectRole',
                inactive-color='#D5DCE0',
                v-model='serviceDetailEditForm.isSender')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("project_detail.project_detail_edit_form.reception")',
              prop='isReceiver')
              ods-switch(
                :disabled='!canModifyProject',
                :active-color='primaryColor',
                @click.native='changeProjectRole',
                inactive-color='#D5DCE0',
                v-model='serviceDetailEditForm.isReceiver')
          ods-col(:span='10')
            ods-form-item.logoItem(label='Logo', prop='logo')
              ods-tooltip(:content='$t("project_detail.buttons.add_logo_tooltip")', placement='bottom')
                ods-button(
                  v-if='canModifyProject',
                  icon='ods-icon-plus',
                  size='medium',
                  circle,
                  @click.native='showUploadDialog')
                  | {{ $t('project_detail.buttons.add_logo') }}
              ods-form-item(:label='serviceDetailEditForm.logo' class='labelNameLogo')
                  ods-tooltip(:content='$t("buttons.btnDelete")', placement='bottom')
                    div.flexClass
                      ods-button.logoButtons(
                        v-if='canModifyProject && serviceDetailEditForm.logo !== null && serviceDetailEditForm.logo.length > 0 ',
                        type='neutral',
                        @click='removeLogo')
                        ods-icon(name='close', size='24', class="botoneraLogo")
                  ods-tooltip(:content='$t("documentation.buttons.download_multiple")', placement='bottom')
                    div.flexClass
                      ods-button.logoButtons(
                        v-if='serviceDetailEditForm.logo !== null && serviceDetailEditForm.logo.length > 0 ',
                        type='neutral',
                        @click='downloadLogo')
                        ods-icon(name='download', size='24', class="botoneraLogo")
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              v-if='canModifyProject'
              :label='$t("project_detail.project_detail_edit_form.is_indra_project")',
              prop='isIndraProject')
              ods-switch(
                :active-color='primaryColor',
                inactive-color='#D5DCE0',
                v-model='serviceDetailEditForm.isIndraProject')
          ods-col(:span='10')
            ods-form-item(
              v-if='canAdminIndra',
              :label='$t("project_detail.facturar")',
              prop='facturar')
              ods-select(
                v-model='serviceDetailEditForm.facturar'
                )
                ods-option(
                  v-for='option in facturarOptions',
                  :key='option.value',
                  :label='option.value',
                  :value='option.value')

    ods-row.form-actions
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            v-if='canModifyProject'
            type='primary',
            size='large'
            @click='saveService("serviceDetailEditForm")')
            | {{ $t('buttons.btnSaveChanges') }}
        ods-tooltip(:content='$t("buttons.btnClear")', placement='bottom')
          ods-button(
            v-if='canModifyProject'
            ref='buttonCancel',
            type='neutral',
            size='large'
            @click='cancelServiceDetailEditForm')
            | {{ $t('buttons.btnClear') }}

    ods-module.collapse
      ods-accordion(@change='loadDataconfiguration')
        ods-accordion-item(
          v-if='canModifyProject',
          name='1')
          template(slot='title')
            span {{ $t('project_detail.configuration_data') }}
            span.info(v-show='!dataconfiguration.length && dataconfigurationMessage') {{ $t('project_detail.no_configuration_data') }}
          //- Tabla de datos de configuracion
          ods-table(
            v-if='dataconfiguration.length > 0 ',
            :data='dataconfiguration',
            :default-sort="{ prop: 'code', order: 'descending' }",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='code',
              :label='$t("project_detail.configuration_data_table.code")',
              :formatter='formatterConfiguration',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='value',
              :label='$t("projects.validations.value")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              prop='typeText',
              :label='$t("project_detail.configuration_data_table.project_type")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              label=''
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='canModifyProject',
                  type='neutral',
                  @click='removeDataConf')
                  ods-icon(name='close', size='16')
          ods-tooltip(:content='$t("project_detail.buttons.add_configuration_data_tooltip")', placement='bottom')
            ods-button.button-collapse-withmargin(
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='isShowDialogDataConfiguration = true')
              | {{ $t('buttons.btnAdd') }}
      ods-accordion(@change='loadValidities')
        ods-accordion-item( name='2')
          template(slot='title')
            span {{ $t('project_detail.validity_document') }}
            span.info(v-show='!validities.length && validitiesMessage') {{ $t('project_detail.no_validity_document') }}
          //- Tabla metodos de entrega de una empresa
          ods-table(
            v-if='validities.length > 0 ',
            :data='validities',
            :default-sort="{ prop: 'name', order: 'ascending' }",
            style='width: 100%',
            @cell-mouse-enter='handleValidityCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='documentName',
              :label='$t("project_detail.validity_document_table.document_type")',
              :show-overflow-tooltip='true',
              :formatter='formatterDocumentType',
              sortable='')
            ods-table-column(
              prop='sender',
              :label='$t("projects.validities.role")',
              :show-overflow-tooltip='true',
              :formatter='formatterRole',
              sortable='')
            ods-table-column(
              prop='codeAlfa3',
              :label='$t("project_detail.validity_document_table.country")',
              :show-overflow-tooltip='true',
              :formatter='formatterCountry',
              sortable='')
            ods-table-column(
              prop='days',
              :label='$t("project_detail.validity_document_table.days")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              label='',
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='canAdminIndra',
                  type='neutral',
                  @click='removeValidity')
                  ods-icon(name='close', size='16')
          ods-tooltip(:content='$t("project_detail.buttons.add_validity_document_tooltip")', placement='bottom')
            ods-button.button-collapse-withmargin(
              v-if='canAdminIndra',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='isShowDialogValidity = true')
              | {{ $t('project_detail.buttons.add_validity_document') }}
      ods-accordion(@change='loadCommunicationsmethods')
        ods-accordion-item( name='3')
          template(slot='title')
            span {{ $t('project_detail.delivery_methods') }}
            span.info(v-show='!communicationsmethods.length && communicationsmethodsMessage') {{ $t('project_detail.no_delivery_methods') }}
          //- Tabla metodos de entrega de una empresa
          ods-table(
            v-if='communicationsmethods.length > 0 ',
            :data='communicationsmethods',
            :default-sort="{ prop: 'name', order: 'ascending' }",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnterMethod',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='name',
              :label='$t("party_detail.delivery_methods_table.name")',
              :show-overflow-tooltip='true',
              :formatter='formatterDeliveryMethods',
              sortable='')
            ods-table-column(
              prop='sender',
              :label='$t("party_detail.delivery_methods_table.sender")',
              :show-overflow-tooltip='true',
              :formatter='formatterSenderType',
              sortable='')
            ods-table-column(
              label='',
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='canAdminIndra',
                  type='neutral',
                  @click='removeCommunicationsMethods')
                  ods-icon(name='close', size='16')
          ods-tooltip(:content='$t("project_detail.buttons.add_delivery_methods_tooltip")', placement='bottom')
            ods-button.button-collapse-withmargin(
              v-if='canAdminIndra',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='openDialogDeliveryMehods()')
              | {{ $t('project_detail.buttons.add_delivery_methods') }}
      ods-accordion(@change='loadCommunicationsmethodCredentials')
        ods-accordion-item( name='3b')
          template(slot='title')
            span {{ $t('project_detail.delivery_methods_credentials') }}
            span.info(v-show='!communicationsmethodCredentials.length && communicationsmethodCredentialsMessage') {{ $t('project_detail.no_delivery_methods') }}
          //- Tabla metodos de entrega de una empresa
          ods-table(
            v-if='communicationsmethodCredentials.length > 0 ',
            :data='communicationsmethodCredentials',
            :default-sort="{ prop: 'name', order: 'ascending' }",
            style='width: 100%',
            @cell-mouse-enter='handleCredentialsCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='partyNameNif',
              :label='$t("party_detail.delivery_methods_table.party")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='name',
              :label='$t("party_detail.delivery_methods_table.name")',
              :show-overflow-tooltip='true',
              :formatter='formatterDeliveryMethods',
              sortable='')
            ods-table-column(
              prop='user',
              :label='$t("party_detail.delivery_methods_table.user")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              label='',
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='canAdminProject && scope.row.delete',
                  type='neutral',
                  @click='removeCommunicationsMethodCredentials')
                  ods-icon(name='close', size='16')
          ods-tooltip(:content='$t("party_detail.buttons.add_delivery_method_tooltip")', placement='bottom')
            ods-button.button-collapse-withmargin(
              v-if='canAdminProject',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='openDialogDeliveryMehodsCredentials()')
              | {{ $t('party_detail.buttons.add_delivery_method') }}
        //- Acordeon de validaciones
      ods-accordion(@change='loadValidationsData')
        ods-accordion-item(name='4')
          template(slot='title')
            span {{ $t('project_detail.validations') }}
            span.info(v-show='!validationsData.length && validationsDataMessage') {{ $t('project_detail.no_active_validations') }}
          //- Tabla de datos de validaciones
          ods-table(
            v-if='validationsData.length > 0 ',
            :data='validationsData',
            :default-sort="{ prop: 'name', order: 'descending' }",
            style='width: 100%',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='name',
              :label='$t("projects.validations.name")',
              :show-overflow-tooltip='true',
              :formatter='formatterName'
              sortable='')
            ods-table-column(
              prop='documentType',
              :label='$t("projects.validations.document_type")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              prop='sender',
              :formatter='formatterRole',
              :label='$t("projects.validations.role")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              prop='value',
              :label='$t("projects.validations.value")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              prop='country',
              :label='$t("projects.validations.country")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              prop='documentFormat',
              :label='$t("projects.validations.document_format")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              label=''
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='canAdminIndra',
                  type='neutral',
                  @click='removeValidation(scope.row)')
                  ods-icon(name='close', size='16')
          ods-tooltip(v-if='canAdminIndra', :content='$t("project_detail.buttons.add_validation_tooltip")', placement='bottom')
            ods-button.button-collapse-withmargin(
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='openDialogAddValidation()')
              | {{ $t('buttons.btnAdd') }}
      ods-accordion(@change='loadPendingtasksData')
        ods-accordion-item(name='5')
          template(slot='title')
            span {{ $t('project_detail.pendingtasks') }}
            span.info(v-show='!pendingtasksData.length && pendingtasksDataMessage') {{ $t('project_detail.no_pendingtasks') }}
          //- Tabla tareas pendientes
          ods-table(
            v-if='pendingtasksData.length > 0 ',
            :data='pendingtasksData',
            :default-sort="{ prop: 'status', order: 'ascending' }",
            style='width: 100%',
            @cell-mouse-enter='handlePendingtasksCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='status',
              :formatter='formatterStatus',
              :label='$t("projects.pendingtasks.status")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='module',
              :formatter='formatterModule',
              :label='$t("projects.pendingtasks.module")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              label=''
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='canAdminIndra',
                  type='neutral',
                  @click='removePendingTask')
                  ods-icon(name='close', size='16')
          ods-tooltip(:content='$t("project_detail.buttons.add_pendingtask_tooltip")', placement='bottom')
            ods-button.button-collapse-withmargin(
              v-if='canAdminIndra',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='openDialogAddPendingTask()')
              | {{ $t('buttons.btnAdd') }}
      //- Acordeon Bloque PDF
      ods-accordion(@change='loadPdfData')
        ods-accordion-item(name='6')
          template(slot='title')
            span {{ $t('project_detail.visualize_pdf') }}
            span.info(v-show='!pdfData.length && pdfDataMessage') {{ $t('project_detail.no_active_PDF') }}
          //- Tabla de datos de visualizaciones
          ods-table(
            v-if='pdfData.length > 0 ',
            :data='pdfData',
            :default-sort="{ prop: 'name', order: 'descending' }",
            style='width: 100%',
            @cell-mouse-enter='handlePDFCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='name',
              :label='$t("projects.validations.name")',
              :show-overflow-tooltip='true',
              :formatter='formatterVisualizationName'
              sortable='')
            ods-table-column(
              prop='documentType',
              :label='$t("projects.validations.document_type")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              prop='issueDirection',
              :formatter='formatterDirection',
              :label='$t("projects.validations.role")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              prop='communicationMethod',
              :label='$t("projects.validations.comm_method")',
              :show-overflow-tooltip='true'
              :formatter='formatterDeliveryMethods',
              sortable='')
            ods-table-column(
              label=''
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='canAdminIndra',
                  type='neutral',
                  @click='removePDFVisualization')
                  ods-icon(name='close', size='16')
          ods-tooltip(v-if='canAdminIndra', :content='$t("project_detail.buttons.add_visualization_tooltip")', placement='bottom')
            ods-button.button-collapse-withmargin(
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='openDialogAddPDFVisualization()')
              | {{ $t('buttons.btnAdd') }}
      ods-accordion(@change='loadRejectioncategoryData')
        ods-accordion-item(name='7')
          template(slot='title')
            span {{ $t('project_detail.rejectionCategories') }}
            span.info(v-show='!rejectioncategoryData.length && rejectioncategoryDataMessage') {{ $t('project_detail.no_rejectionCategories') }}
          //- Tabla categorias de rechazo
          ods-table(
            v-if='rejectioncategoryData.length > 0 ',
            :data='rejectioncategoryData',
            :default-sort="{ prop: 'category', order: 'ascending' }",
            style='width: 100%',
            @cell-mouse-enter='handleRejectionCategoryCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='category',
              :formatter='formatterCategory',
              :label='$t("projects.rejectionCategories.name")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='visible',
              :formatter='formatterVisible',
              :label='$t("projects.rejectionCategories.visible")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              label=''
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='canAdminIndra',
                  type='neutral',
                  @click='removeRejectionCategory')
                  ods-icon(name='close', size='16')
          ods-tooltip(:content='$t("project_detail.buttons.add_rejectionCategory_tooltip")', placement='bottom')
            ods-button.button-collapse-withmargin(
              v-if='canAdminIndra',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='openDialogAddRejectionCategory()')
              | {{ $t('buttons.btnAdd') }}
        //- Desplegable CONFIGURACION DE RECEPCION DE ALBARANES
        ods-accordion(@change='loadProjectDeliveryNoteType')
          ods-accordion-item( name='6',
            v-if='this.serviceDetailEditForm.isReceiver')
              template(slot='title')
                span {{ $t('party_detail.reception_delivery_note_config') }}
                span.info(v-show='projectDeliveryNoteType != null && projectDeliveryNoteType != undefined && !projectDeliveryNoteType.length && projectDeliveryNoteTypeMessage') {{ $t('party_detail.no_project_reception_delivery_note_config')}}
              ods-table(
                v-if='projectDeliveryNoteType.length > 0 ',
                :data='projectDeliveryNoteType',
                :default-sort="{ prop: 'deliveryNoteTypeCode', order: 'ascending' }",
                @cell-mouse-enter='handleCellMouseEnterDeliveryNoteType',
                style='width: 100%',
                highlight-current-row,
                size='mini',
                fit)
                ods-table-column(
                  prop='deliveryNoteTypeCode',
                  :label='$t("party_detail.reception_delivery_note_config_table.delivery_note_type")',
                  :formatter='formatterDeliveryNoteType'
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  label='',
                  width='80')
                  template(slot-scope='scope')
                    ods-button(
                      v-if='canAdminIndra',
                      type='neutral',
                      @click='removeProjectDeliveryNoteType')
                      ods-icon(name='close', size='16')
              ods-tooltip(:content='$t("party_detail.buttons.add_delivery_note_type_tooltip")', placement='bottom')
                ods-button.button-collapse(
                  v-if='canAdminIndra',
                  icon='ods-icon-plus',
                  size='small',
                  circle,
                  @click.native='showDialogAddProjectDeliveryNoteType()')
                  | {{ $t('party_detail.buttons.add_delivery_method') }}
      ods-accordion(@change='loadEmailTypeData')
        ods-accordion-item(name='8')
          template(slot='title')
            span {{ $t('project_detail.emailType') }}
            span.info(v-show='!emailTypeData.length && emailTypeDataMessage') {{ $t('project_detail.no_emailType') }}
          //- Tabla tipologías de correos
          ods-table(
            v-if='emailTypeData.length > 0 ',
            :data='emailTypeData',
            :default-sort="{ prop: 'type', order: 'ascending' }",
            style='width: 100%',
            @cell-mouse-enter='handleEmailTypeCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='type',
              :label='$t("projects.emailType.type")',
              :show-overflow-tooltip='true',
              :formatter='formatterEmailType'
              sortable='')
            ods-table-column(
              prop='value',
              :label='$t("projects.emailType.value")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              label=''
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='canAdminIndra',
                  type='neutral',
                  @click='removeEmailType')
                  ods-icon(name='close', size='16')
          ods-tooltip(:content='$t("project_detail.buttons.add_emailype_tooltip")', placement='bottom')
            ods-button.button-collapse-withmargin(
              v-if='canAdminIndra',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='openDialogAddEmailType()')
              | {{ $t('buttons.btnAdd') }}
      ods-accordion(@change='loadMimeconfiguration')
        ods-accordion-item(
          v-if='canAdminIndra',
          name='9')
          template(slot='title')
            span {{ $t('project_detail.mime_configuration') }}
            span.info(v-show='!mimeconfiguration.length && mimeconfigurationMessage') {{ $t('project_detail.no_mime_configuration') }}
          //- Tabla de datos de configuracion
          ods-table(
            v-if='mimeconfiguration.length > 0 ',
            :data='mimeconfiguration',
            :default-sort="{ prop: 'code', order: 'descending' }",
            style='width: 100%',
            @cell-mouse-enter='handleMimeCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='mimeFrom',
              :label='$t("project_detail.mime_configuration_table.mime_from")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='mimeSender',
              :label='$t("project_detail.mime_configuration_table.mime_sender")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              prop='mimeReplyTo',
              :label='$t("project_detail.mime_configuration_table.mime_reply_to")',
              :show-overflow-tooltip='true'
              sortable='')
            ods-table-column(
              label=''
              width='80')
              template(slot-scope='scope')
                ods-button(
                  v-if='canAdminIndra',
                  type='neutral',
                  @click='removeMimeConf')
                  ods-icon(name='close', size='16')
          ods-tooltip(:content='$t("project_detail.buttons.add_mime_configuration_tooltip")', placement='bottom')
            ods-button.button-collapse-withmargin(
              v-if='!this.mimeconfiguration.length',
              icon='ods-icon-plus',
              size='small',
              circle,
              @click.native='isShowDialogMimeConfiguration = true')
              | {{ $t('buttons.btnAdd') }}

        //- Desplegable Documentos y formatos emiten o reciben
        ods-accordion-item( name='10',
          v-if='canAdminIndra')
            template(slot='title')
              span {{ $t('project_detail.document_format') }}
              span.info(v-show='!projectDocumentFormat.length') {{ $t('project_detail.no_document_format') }}
            ods-table(
              v-if='projectDocumentFormat.length > 0 ',
              :data='projectDocumentFormat',
              :default-sort="{ prop: 'documentType', order: 'ascending' }",
              @cell-mouse-enter='handleCellMouseEnterFormat',
              style='width: 100%',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='documentType',
                :label='$t("project_detail.document_format_table.documentType")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='documentFormatName',
                :label='$t("project_detail.document_format_table.format")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                prop='sender',
                :label='$t("project_detail.document_format_table.sender")',
                :show-overflow-tooltip='true',
                :formatter='formatterSenderType',
                sortable='')
              ods-table-column(
                prop='priority',
                :label='$t("project_detail.document_format_table.priority")',
                :show-overflow-tooltip='true',
                sortable='')
              ods-table-column(
                label='',
                width='80')
                template(slot-scope='scope')
                  ods-button(
                    v-if='canAdminIndra',
                    type='neutral',
                    @click='removeProjectDocumentFormat')
                    ods-icon(name='close', size='16')
            ods-tooltip(:content='$t("project_detail.buttons.add_documentFormat_data_tooltip")', placement='bottom')
              ods-button.button-collapse(
                v-if='canAdminIndra',
                icon='ods-icon-plus',
                size='small',
                circle,
                @click.native='showDialogProjectDocumentFormat()')
                | {{ $t('buttons.btnAdd') }}

    //- Dialogo Cargar logo
    ods-dialog(
      ref='dialogAddLogo'
      :title='$t("project_detail.dialog_add_logo.title")',
      :visible.sync='isShowDialogAddLogo',
      @close='handleCloseDialogAddLogo',
      width='30%')
      ods-form(
        ref='formDialogAddLogo',
        :model='formDialogAddLogo'
        :rules='rulesDialogAddLogoForm')
        ods-form-item(prop='fichero', ref='form-item-upload')
          ods-upload(
            v-model='formDialogAddLogo.fichero',
            ref='upload',
            action='#',
            :auto-upload='false',
            :on-change='onSuccessUpload',
            :on-remove='handleRemoveUpload',
            :file-list='fileList',
            :accept= 'extensionFormats.toString()')
            ods-button(
              icon='ods-icon-plus'
              size='small',
              circle)
              | {{ $t('msg_generics.file_selected') }}
      span.dialog-footer(slot='footer')
        ods-tooltip(:content='$t("project_detail.buttons.add_logo_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            @click.native='onSubmitAddLogo("formDialogAddLogo")')
            | {{ $t('project_detail.buttons.add_logo') }}

    //- Dialogo Datos de configuración
    ods-dialog(
      ref='dialogDataConfiguration'
      :title='$t("project_detail.dialog_add_configuration_data.title")',
      :visible.sync='isShowDialogDataConfiguration',
      @close='handleCloseDialogDataConfiguration',
      width='30%')
      ods-form(
        ref='formDialogDataConfiguration',
        :model='dialogDataConfigurationForm',
        :rules='rulesDialogDataConfigurationForm')
        ods-form-item(
          prop='configurationId',
          :label='$t("project_detail.dialog_add_configuration_data.configuration.label")')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='dialogDataConfigurationForm.configurationId',
            filterable,
            :placeholder='$t("project_detail.dialog_add_configuration_data.configuration.placeholder")')
            ods-option(
              v-for='option in optionsFilterProjectConfiguration',
              :key='option.id',
              :label="$t('configuration_table.'+option.code)",
              :value='option.id')
        ods-form-item(
          prop='type',
          :label='$t("project_detail.dialog_add_configuration_data.type.label")')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='dialogDataConfigurationForm.type',
            filterable,
            :placeholder='$t("project_detail.dialog_add_configuration_data.type.placeholder")')
            ods-option(
              v-for='option in comboTypeList',
              :key='option.code',
              :label='option.description',
              :value='option.code')
        ods-form-item(
          :label='$t("projects.validations.value")',
          prop='value')
          ods-input(
            v-model='dialogDataConfigurationForm.value')
      span.dialog-footer
        ods-button(
          type='primary',
          @click.native='onSubmitAddDataConfiguration("formDialogDataConfiguration")')
          | {{ $t('buttons.btnAdd') }}
    //- Dialogo de configuración mime
    ods-dialog(
      ref='dialogMimeConfiguration'
      :title='$t("project_detail.dialog_add_mime_configuration.title")',
      :visible.sync='isShowDialogMimeConfiguration',
      @close='handleCloseDialogMimeConfiguration',
      width='30%')
      ods-form(
        ref='formDialogMimeConfiguration',
        :model='dialogMimeConfigurationForm',
        :rules='rulesDialogMimeConfigurationForm')
        ods-form-item(
          ref='mimeFromFormItem'
          :label='$t("project_detail.dialog_add_mime_configuration.mime_from.label")',
          prop='mimeFrom')
          ods-input(
            v-model='dialogMimeConfigurationForm.mimeFrom')
        ods-form-item(
          ref='mimeSenderFormItem'
          :label='$t("project_detail.dialog_add_mime_configuration.mime_sender.label")',
          prop='mimeSender')
          ods-input(
            v-model='dialogMimeConfigurationForm.mimeSender')
        ods-form-item(
          ref='mimeReplyToFormItem'
          :label='$t("project_detail.dialog_add_mime_configuration.mime_reply_to.label")',
          prop='mimeReplyTo')
          ods-input(
            v-model='dialogMimeConfigurationForm.mimeReplyTo')
      span.dialog-footer
        ods-button(
          type='primary',
          @click.native='onSubmitAddMimeConfiguration("formDialogMimeConfiguration")')
          | {{ $t('buttons.btnAdd') }}
    //- Dialogo métodos de entrega
    ods-dialog(
      ref='dialogCommunicationsMethods'
      :title='$t("project_detail.dialog_add_delivery_method.title")',
      :visible.sync='isShowDialogDeliveryMehods',
      @close='handleCloseDialogCommunicationsMethods',
      width='30%')
      ods-form(
        ref='formDialogCommunicationsMethods',
        :model='dialogCommunicationsMethodsForm',
        :rules='rulesDialogCommunicationsMethodsForm')
          ods-form-item(
            v-if='showCommunicationFilter',
            :label='$t("party_detail.delivery_methods_table.sender")',
            prop='communicationsmethodsSenderId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeCommunicationsSender',
              v-model='dialogCommunicationsMethodsForm.communicationsmethodsSenderId',
              filterable)
              ods-option(
                v-for='option in optionsCommunicationsMethodsSender',
                :key='option.id',
                :label='option.name',
                :value='option.id')
          ods-form-item(
            prop='communicationsmethodsId',
            :label='$t("project_detail.dialog_add_delivery_method.method.placeholder")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogCommunicationsMethodsForm.communicationsmethodsId',
              filterable,
              :placeholder='$t("project_detail.dialog_add_delivery_method.method.placeholder")')
              ods-option(
                v-for='option in optionsFilterCommunicationsMethods',
                :key='option.id',
                :label="$t('communication_method.'+option.name)",
                :value='option.id')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddCommunicationsMethods("formDialogCommunicationsMethods")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo métodos de entrega - credenciales
    ods-dialog(
      ref='dialogCommunicationsMethodsCredentials',
      :title='$t("party_detail.dialog_add_delivery_methods_credentials.title")',
      :visible.sync='isShowDialogDeliveryMehodsCredentials',
      @close='handleCloseDialogCommunicationsMethodsCredentials',
      width='30%')
      ods-form(
        ref='formDialogCommunicationsMethodsCredentials',
        :model='dialogCommunicationsMethodsFormCredentials',
        :rules='rulesDialogCommunicationsMethodsFormCredentials')
          ods-form-item(
            :label='$t("party_detail.delivery_methods_table.party")',
            prop='communicationsmethodsPartyId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeCommunicationsParty',
              v-model='dialogCommunicationsMethodsFormCredentials.communicationsmethodsPartyId',
              :placeholder='$t("invoices.filters.seller.placeholder")',
              filterable,
              :filter-method='filterPartiesSeller')
              ods-option(
                  v-for='seller in optionsSeller',
                  :key='seller.id',
                  :label="(seller.taxIdentificationNumber?seller.taxIdentificationNumber + ' - ':'') + seller.tradeName",
                  :value='seller.id')
          ods-form-item(
            :label='$t("party_detail.dialog_add_delivery_methods.method.label")',
            prop='communicationsmethodsId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeCommunicationsCredentials',
              v-model='dialogCommunicationsMethodsFormCredentials.communicationsmethodsId',
              :placeholder='$t("party_detail.dialog_add_delivery_methods.method.placeholder")',
              filterable)
              ods-option(
                v-for='option in optionsCommunicationsMethodsCredentials',
                :key='option.id',
                :label="$t('communication_method.' + option.name)",
                :value='option.id')
          ods-form-item(
            v-if='showCommunicationUser',
            :label='$t("party_detail.delivery_methods_table.user")',
            prop='user')
            ods-input(
              v-model='dialogCommunicationsMethodsFormCredentials.user')
          ods-form-item(
            v-if='showCommunicationPass',
            :label='$t("party_detail.delivery_methods_table.password")',
            prop='password')
            ods-input(
              show-password
              type='password',
              v-model='dialogCommunicationsMethodsFormCredentials.password')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addCommunicationsMethodsCredentials("formDialogCommunicationsMethodsCredentials")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo CONFIGURACIÓN DE TIPOS DE ALBARANES ASOCIADOS A LA EMPRESA
    ods-dialog(
      ref='dialogAddProjectDeliveryNoteType',
      :title='$t("party_detail.dialog_add_party_delivery_note_type.title")',
      :visible.sync='isShowDialogAddProjectDeliveryNoteType',
      @close='handleCloseDialogAddProjectDeliveryNoteType',
      width='20%')
      ods-form(
        ref='formDialogAddProjectDeliveryNoteType',
        :model='dialogAddProjectDeliveryNoteTypeForm',
        :rules='rulesDialogAddProjectDeliveryNoteTypeForm')
          ods-form-item(
            :label='$t("party_detail.dialog_add_party_delivery_note_type.method.deliveyNoteType")',
            :default='5'
            prop='deliveryNoteTypeId')
            ods-select(
                  v-model='dialogAddProjectDeliveryNoteTypeForm.deliveryNoteTypeId',
                  :disabled='(optionsDeliveryNoteType && optionsDeliveryNoteType.length === 1)')
                  ods-option(
                    v-for='deliveryNoteType in optionsDeliveryNoteType',
                    :key='deliveryNoteType.deliveryNoteTypeId',
                    :label='formatterDeliveryNoteType(deliveryNoteType)',
                    :value='deliveryNoteType.deliveryNoteTypeId')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addProjectDeliveryNoteType("formDialogAddProjectDeliveryNoteType")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo añadir vigencia
    ods-dialog(
      ref='dialogValidities'
      :title='$t("project_detail.dialog_add_validities.title")',
      :visible.sync='isShowDialogValidity',
      @close='handleCloseDialogValidities',
      width='30%')
      ods-form(
        ref='formDialogValidities',
        :model='dialogValiditiesForm',
        :rules='rulesDialogValiditiesForm')
          ods-form-item(
            prop='documentType',
            :label='$t("projects.validities.document_type")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogValiditiesForm.documentType',
              filterable,
              :placeholder='$t("projects.validities.document_type")')
              ods-option(
                v-for='option in optionsDocumentType',
                :key='option.id',
                :label='option.code',
                :value='option.id')
          ods-form-item(
            prop='role',
            :label='$t("projects.validities.role")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogValiditiesForm.role',
              filterable,
              :placeholder='$t("projects.validities.role")')
              ods-option(
                v-for='option in comboRoleList',
                :key='option.code',
                :label='option.description',
                :value='option.code')
          ods-form-item(
            prop='country',
            :label='$t("projects.validities.country")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogValiditiesForm.country',
              filterable,
              :placeholder='$t("projects.validities.country")')
              ods-option(
                v-for='option in countries',
                :key='option.id',
                :label='option.name',
                :value='option.id')
          ods-form-item(
              :label='$t("projects.validities.validity")',
              prop='validity')
              ods-input(
                v-model='dialogValiditiesForm.validity')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddValidity("formDialogValidities")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo añadir validaciones
    ods-dialog(
      ref='dialogValidations'
      :title='$t("project_detail.dialog_add_validations.title")',
      :visible.sync='isShowDialogValidations',
      @close='handleCloseDialogValidations',
      width='30%')
      ods-form(
        ref='formDialogValidations',
        :model='dialogValidationsForm',
        :rules='rulesDialogValidationsForm')
          ods-form-item(
            prop='validationId',
            :label='$t("project_detail.dialog_add_validations.validation.title")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeValidation',
              v-model='dialogValidationsForm.validationId',
              filterable,
              :placeholder='$t("project_detail.dialog_add_validations.validation.placeholder")')
              ods-option(
                v-for='option in optionsProjectValidations',
                :key='option.idBusinessValidation',
                :label="option.name",
                :value='option.idBusinessValidation')
          ods-form-item(
            prop='documentType',
            :label='$t("projects.validations.document_type")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              @change='onChangeDocumentType',
              v-model='dialogValidationsForm.documentType',
              filterable,
              :placeholder='$t("projects.validations.document_type")')
              ods-option(
                v-for='option in optionsDocumentType',
                :key='option.id',
                :label='option.code',
                :value='option.id')
          ods-form-item(
            prop='country',
            :label='$t("projects.validations.country")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogValidationsForm.country',
              filterable,
              :placeholder='$t("projects.validities.country")')
              ods-option(
                v-for='option in countries',
                :key='option.id',
                :label='option.name',
                :value='option.id')
          ods-form-item(
            prop='documentFormat',
            v-if='showComboFormat'
            :label='$t("projects.validations.document_format")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogValidationsForm.documentFormat',
              filterable,
              :placeholder='$t("projects.validations.document_format")')
              ods-option(
                v-for='option in formatos',
                :key='option.name',
                :label='option.name',
                :value='option.name')
          ods-form-item(
            prop='role',
            :label='$t("projects.validations.role")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogValidationsForm.role',
              filterable,
              :placeholder='$t("projects.validations.role")')
              ods-option(
                v-for='option in comboValidationRoleList',
                :key='option.code',
                :label='option.description',
                :value='option.code')
          ods-form-item(
            :label='$t("projects.validations.value")',
            prop='value')
            ods-input(
              v-model='dialogValidationsForm.value')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddValidation("formDialogValidations")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo añadir visualización PDF
    ods-dialog(
      ref='dialogPDFVisualization'
      :title='$t("project_detail.dialog_add_visualization.title")',
      :visible.sync='isShowDialogPDFVisualizations',
      @close='handleCloseDialogPDFVisualizations',
      width='30%')
      ods-form(
        ref='formDialogPDFVisualizations',
        :model='dialogPDFVisualizationsForm',
        :rules='rulesDialogPDFVisualizationsForm')
          ods-form-item(
            prop='documentType',
            :label='$t("projects.validations.document_type")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPDFVisualizationsForm.documentType',
              filterable,
              @change='getDisplayDocumentsByDocumentType',
              :placeholder='$t("projects.validations.document_type")')
              ods-option(
                v-for='option in optionsDocumentType',
                :key='option.id',
                :label='option.code',
                :value='option.id')
          ods-form-item(
            prop='visualizationId',
            v-if='isSelectedDocType',
            :label='$t("project_detail.dialog_add_visualization.visualization.placeholder")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPDFVisualizationsForm.visualizationId',
              filterable,
              :placeholder='$t("project_detail.dialog_add_visualization.visualization.placeholder")')
              ods-option(
                v-for='option in optionsProjectPDFVisualizations',
                :key='option.id',
                :label='$t("display_documents." + option.name)',
                :value='option.id')
          ods-form-item(
            prop='issueDirection',
            v-if='isSelectedDocType',
            :label='$t("projects.validations.role")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPDFVisualizationsForm.issueDirection',
              filterable,
              :placeholder='$t("projects.validations.role")')
              ods-option(
                v-for='option in comboDirectionList',
                :key='option.code',
                :label='option.description',
                :value='option.code')
          ods-form-item(
            prop='communicationsmethodsId',
            v-if='isSelectedDocType',
            :label='$t("project_detail.dialog_add_delivery_method.method.placeholder")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPDFVisualizationsForm.communicationsmethodsId',
              filterable,
              :placeholder='$t("project_detail.dialog_add_delivery_method.method.placeholder")')
              ods-option(
                v-for='option in communicationsmethods',
                :key='option.id',
                :label="$t('communication_method.'+option.name)",
                :value='option.id')
      span.dialog-footer(slot='footer')
        ods-button(
          :disabled='!isSelectedDocType'
          type='primary',
          @click.native='onSubmitAddPDFVisualization("formDialogPDFVisualizations")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo estados tareas pendientes
    ods-dialog(
      ref='dialogPendingtasks'
      :title='$t("project_detail.dialog_add_pendingtask.title")',
      :visible.sync='isShowDialogPendingtask',
      @close='handleCloseDialogPendingtasks',
      width='30%')
      ods-form(
        ref='formDialogPendingtasks',
        :model='dialogPendingtasksForm',
        :rules='rulesDialogPendingtasksForm')
          ods-form-item(
            :label='$t("project_detail.pendingtask_table.status")',
            prop='statusId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPendingtasksForm.statusId',
              filterable,
              :placeholder='$t("project_detail.pendingtask_table.statusplaceholder")')
              ods-option(
                v-for='option in optionsStatus',
                :key='option.id',
                :label='option.code',
                :value='option.id')
          ods-form-item(
            prop='statuschangeId',
            :label='$t("project_detail.pendingtask_table.statuschange")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogPendingtasksForm.statuschangeId',
              filterable,
              :placeholder='$t("project_detail.pendingtask_table.statusplaceholder")')
              ods-option(
                v-for='option in optionsStatuschange',
                :key='option.id',
                :label='option.code',
                :value='option.id')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddPendingtasks("formDialogPendingtasks")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo de tipologías de correo
    ods-dialog(
      ref='dialogEmailType'
      :title='$t("project_detail.dialog_add_emailType.title")',
      :visible.sync='isShowDialogEmailType',
      @close='handleCloseDialogEmailType',
      width='30%')
      ods-form(
        ref='formDialogEmailType',
        :model='dialogEmailTypeForm',
        :rules='rulesDialogEmailTypeForm')
          ods-form-item(
            :label='$t("project_detail.dialog_add_emailType.emailType.title")',
            prop='emailTypeId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogEmailTypeForm.emailTypeId',
              filterable,
              :placeholder='$t("project_detail.emailTypePlaceholder")')
              ods-option(
                v-for='option in optionsEmailType',
                :key='option.id',
                :label='$t("email_type." + option.name)',
                :value='option.id')
          ods-form-item(
            prop='emailValue',
            :label='$t("projects.emailType.value")')
            ods-input(
              :placeholder='$t("projects.emailType.value")',
              v-model='dialogEmailTypeForm.emailValue')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddEmailProjectType("formDialogEmailType")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo categorías de rechazo
    ods-dialog(
      ref='DialogRejectionCategories'
      :title='$t("project_detail.dialog_add_rejectionCategory.title")',
      :visible.sync='isShowDialogRejectionCategory',
      @close='handleCloseDialogRejectionCategories',
      width='30%')
      ods-form(
        ref='formDialogRejectionCategories',
        :model='dialogRejectionCategoriesForm',
        :rules='rulesDialogRejectionCategoriesForm')
          ods-form-item(
            :label='$t("project_detail.rejectionCategory_table.category")',
            prop='nameId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogRejectionCategoriesForm.nameId',
              filterable,
              :placeholder='$t("project_detail.rejectionCategory_table.category")')
              ods-option(
                v-for='option in optionsCategory',
                :key='option.id',
                :label='$t("categories." + option.code)',
                :value='option.id')
          ods-form-item(
            prop='visibleId',
            :label='$t("project_detail.rejectionCategory_table.visible")')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogRejectionCategoriesForm.visibleId',
              filterable,
              :placeholder='$t("project_detail.rejectionCategory_table.visible")')
              ods-option(
                v-for='option in optionsVisible',
                :key='option.id',
                :label='option.code',
                :value='option.id')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddRejectionCategory("formDialogRejectionCategories")')
          | {{ $t('buttons.btnAdd') }}

    //- Dialogo Documentos y formatos emiten o reciben
    ods-dialog(
      ref='dialogAddProjectDocumentFormat',
      :title='$t("project_detail.dialog_add_document_format.title")',
      :visible.sync='isShowDialogProjectDocumentFormat',
      @close='handleCloseDialogProjectDocumentFormat',
      width='30%')
      ods-form(
        ref='formDialogAddProjectDocumentFormat',
        :model='dialogProjectDocumentFormatForm',
        :rules='rulesDialogProjectDocumentFormatForm')
          ods-form-item(
            :label='$t("project_detail.dialog_add_document_format.format.labelType")',
            prop='documentType')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogProjectDocumentFormatForm.documentType',
              :placeholder='$t("project_detail.dialog_add_document_format.format.placeholder")',
              @change='onChangeSelection',
              filterable)
              ods-option(
                v-for='option in projectDocumentType',
                :key='option.id',
                :label="$t('auditory_doc_type.' + option.code)",
                :value='option.id')
          ods-form-item(
            :label='$t("project_detail.dialog_add_document_format.format.labelFormat")',
            prop='documentFormat')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogProjectDocumentFormatForm.documentFormat',
              :placeholder='$t("project_detail.dialog_add_document_format.format.placeholder")',
              filterable)
              ods-option(
                v-for='option in projectDocumentFormatByType',
                :key='option.id',
                :label="$t(option.name)",
                :value='option.id')
          ods-form-item(
            :label='$t("project_detail.document_format_table.sender")',
            prop='senderId')
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='dialogProjectDocumentFormatForm.senderId',
              filterable)
              ods-option(
                v-for='option in optionsProjectDocumentFormatSender',
                :key='option.id',
                :label='option.name',
                :value='option.id')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='addProjectDocumentFormat("formDialogAddProjectDocumentFormat")')
          | {{ $t('buttons.btnAdd') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-servicio',
  mixins: [Utils],
  data () {
    const checkIntegerNumber = (rule, value, callback) => {
      if (!this.checkCorrectNumberOrderLine(value)) {
        if (this.getCharFailedNumeric(value) === 'NoNumeric') {
          callback(new Error(this.$t('msg_generics.format_invalid')))
        } else {
          callback(new Error(this.$t('msg_generics.format_invalid') + '. ' + this.$t('msg_generics.character_invalid') + this.getCharFailedNumeric(value)))
        }
      } else if (this.countDecimals(value) > 6) {
        callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
      }
      callback()
    }
    const self = this
    const checkNumber = (rule, value, callback) => {
      self.validationValue = self.dialogValidationsForm.value
      if (value === '') {
        callback()
      } else {
        if (self.validationname && (self.validationname.indexOf('accounting') >= 0 || self.validationname.indexOf('contables') >= 0 ||
        self.validationname.toUpperCase().indexOf('TOTAL') >= 0 ||
        self.validationname.indexOf('contabili') >= 0 || self.validationname.indexOf('contábeis') >= 0 || self.validationname.indexOf('ACCOUNTING') >= 0)) {
          if (!this.checkCorrectNumber(value, false)) {
            if (this.getCharFailedNumeric(value) === 'NoNumeric') {
              callback(new Error(this.$t('msg_generics.format_invalid')))
            } else {
              callback(new Error(this.$t('msg_generics.format_invalid') + '. ' + this.$t('msg_generics.character_invalid') + this.getCharFailedNumeric(value)))
            }
          } else if (this.countDecimals(value) > 6) {
            callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
          } else {
            self.validationValue = parseFloat(self.dialogValidationsForm.value.replace(',', '.'))
            callback()
          }
        } else {
          callback()
        }
      }
    }

    const checkAnyStatus = (rule, value, callback) => {
      if (this.dialogPendingtasksForm.statusId == null && this.dialogPendingtasksForm.statuschangeId == null) {
        callback(new Error(this.$t('msg_generics.select_any_required')))
      }
      callback()
    }

    const validateEmails = (rule, value, callback) => {
      // eslint-disable-next-line no-useless-escape
      if (value[value.length - 1] === ';') {
        value = value.substring(0, value.length - 1)
      }
      this.emailList = value.split(';')
      for (let i = 0; i < this.emailList.length; i++) {
        if (!this.checkCorrectEmail(this.emailList[i])) {
          callback(new Error(this.$t('profile.contact.rules_form.email_format')))
        }
      }
      callback()
    }
    const validateEmail = (rule, value, callback) => {
      if (this.dialogMimeConfigurationForm.mimeFrom || this.dialogMimeConfigurationForm.mimeSender || this.dialogMimeConfigurationForm.mimeReplyTo) {
        this.$refs.formDialogMimeConfiguration.clearValidate()
      }
      if (this.checkCorrectEmail(value)) {
        callback()
      } else if (value == null || value === '') {
        callback()
      } else {
        callback(new Error(this.$t('msg_generics.emailKo')))
      }
    }
    const validaAnyMail = (rule, value, callback) => {
      console.log('this.$refs.formDialogMimeConfiguration', this.$refs.formDialogMimeConfiguration)
      console.log('this.dialogMimeConfigurationForm', this.dialogMimeConfigurationForm)
      this.$refs.formDialogMimeConfiguration.clearValidate()
      if (!this.dialogMimeConfigurationForm.mimeFrom && !this.dialogMimeConfigurationForm.mimeSender && !this.dialogMimeConfigurationForm.mimeReplyTo) {
        callback(new Error(this.$t('project_detail.mime_required')))
      } else {
        callback()
      }
    }
    const checkcode = (rule, value, callback) => {
      const regex = RegExp(/^(AVZ|EDI|EDT|EDW|FNX|ITC|PTN|TGE|TPY|VAN|POC)-[0-9]{4}-[áéíóúÁÉÍÓÚa-zA-Z0-9_ ]{1,40}?$/) // eslint-disable-line
      if (value && !regex.test(value.toUpperCase())) {
        callback(new Error(this.$t('project_detail.validation.error_code', regex)))
      }
      callback()
    }
    const checkExtension = (rule, value, callback) => {
      // Obtener la extension, y cuando la tengas, haces la validacion
      if (!this.validateExtension(this.formDialogAddLogo.fichero.name)) {
        this.formDialogAddLogo.fichero = null
        this.$refs['form-item-upload'].resetField('fichero')
        this.fileList = []
        callback(new Error(this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension') + '. ' + this.$t('projects.error.wrongLogoExtension')))
      } else {
        this.fileList = []
        this.fileList.push(this.formDialogAddLogo.fichero)
        callback()
      }
    }
    const checkFileSize = (rule, value, callback) => {
      // Obtener la extension, y cuando la tengas, haces la validacion
      if (this.formDialogAddLogo.fichero && this.formDialogAddLogo.fichero.size > (100 * 1024)) {
        this.formDialogAddLogo.fichero = null
        this.$refs['form-item-upload'].resetField('fichero')
        this.fileList = []
        callback(new Error(this.$t('error.file_size.exceeded', { argumento: this.mazFileSize.toString() + ' KB' })))
      } else {
        this.fileList = []
        this.fileList.push(this.formDialogAddLogo.fichero)
        callback()
      }
    }
    return {

      // Documentos y formatos emiten o reciben
      projectDocumentFormat: [],
      projectDocumentType: [],
      projectDeliveryNoteType: [],
      optionsDeliveryNoteType: [],
      projectDocumentFormatByType: [],
      currentRowProjectDocumentFormat: {},
      currentRowAddProjectDeliveryNoteType: {},
      isShowDialogProjectDocumentFormat: false,
      dialogProjectDocumentFormatForm: {
        documentType: null,
        documentFormat: null,
        senderId: 'emission'
      },
      optionsProjectDocumentFormatSender: [
        {
          id: 'emission',
          name: this.$t('project_type_meth.emission')
        },
        {
          id: 'reception',
          name: this.$t('project_type_meth.reception')
        }
      ],

      // LOGO
      isShowDialogAddLogo: false,
      isShowDialogAddProjectDeliveryNoteType: false,
      formDialogAddLogo: {
        fichero: null
      },
      fileList: [],
      comboTypeList: [],
      comboRoleList: [],
      comboValidationRoleList: [],
      comboDirectionList: [],

      // ACCORDION FLAGS
      projectDeliveryNoteTypeFlag: true,
      projectDeliveryNoteTypeMessage: false,
      dataconfigurationFlag: true,
      dataconfigurationMessage: false,
      mimeconfigurationFlag: true,
      mimeconfigurationMessage: false,
      validitiesFlag: true,
      validitiesMessage: false,
      communicationsmethodsFlag: true,
      communicationsmethodsMessage: false,
      communicationsmethodCredentialsFlag: true,
      communicationsmethodCredentialsMessage: false,
      validationsDataFlag: true,
      validationsDataMessage: false,
      pendingtasksDataFlag: true,
      pendingtasksDataMessage: false,
      pdfDataFlag: true,
      pdfDataMessage: false,
      rejectioncategoryDataFlag: true,
      rejectioncategoryDataMessage: false,
      emailTypeDataFlag: true,
      emailTypeDataMessage: false,

      rulesDialogAddLogoForm: {
        fichero: [
          {
            required: true,
            message: this.$t('msg_generics.file_selected'),
            trigger: 'click'
          },
          { validator: checkExtension },
          { validator: checkFileSize }
        ]
      },
      extensionFormats: ['.jpg', '.jpeg', '.png'],
      mazFileSize: 100,

      // DATOS DE CONFIGURACION
      dataconfiguration: [],
      mimeconfiguration: [],
      currentRowDataconfiguration: {},
      currentRowMimeconfiguration: {},
      facturarOptions: [],
      isShowDialogDataConfiguration: false,
      isShowDialogMimeConfiguration: false,

      dialogAddProjectDeliveryNoteTypeForm: {
        deliveryNoteTypeId: null
      },
      rulesDialogAddProjectDeliveryNoteTypeForm: {
        deliveryNoteTypeId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'blur'
          }
        ]
      },
      dialogDataConfigurationForm: {
        configurationId: null,
        type: null,
        value: null
      },
      dialogMimeConfigurationForm: {
        mimeFrom: null,
        mimeSender: null,
        mimeReplyTo: null
      },
      rulesDialogMimeConfigurationForm: {
        mimeFrom: [
          { validator: validateEmail, trigger: 'change' },
          { max: 255, message: this.$t('validations.maxlenght', { maxlenght: 255 }), trigger: 'change' }
        ],
        mimeSender: [
          { validator: validateEmail, trigger: 'change' },
          { max: 255, message: this.$t('validations.maxlenght', { maxlenght: 255 }), trigger: 'change' }
        ],
        mimeReplyTo: [
          { validator: validateEmail, trigger: 'change' },
          { validator: validaAnyMail, trigger: 'blur' },
          { validator: validaAnyMail, trigger: 'change' },
          { max: 255, message: this.$t('validations.maxlenght', { maxlenght: 255 }), trigger: 'change' }
        ]
      },

      rulesDialogDataConfigurationForm: {
        configurationId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        type: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        value: [
          { max: 255, message: this.$t('msg_generics.max_num_character', { max: 255 }), trigger: 'blur' }
        ]
      },

      rulesDialogProjectDocumentFormatForm: {
        documentType: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'blur'
          }
        ],
        documentFormat: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'blur'
          }
        ]
      },

      // Metodos de entrega
      communicationsmethods: [],
      communicationsmethodCredentials: [],
      isShowDialogDeliveryMehods: false,
      isShowDialogDeliveryMehodsCredentials: false,
      currentRowProjectMethod: {},
      currentRowPartyMethod: {},
      showCommunicationFilter: false,
      showCommunicationUser: false,
      showCommunicationPass: false,
      optionsSeller: [],
      auxListPartiesSeller: [],
      optionsCommunicationsMethodsCredentials: [],
      optionsCommunicationsMethodsSender: [
        {
          id: 'emission',
          name: this.$t('party_type_meth.emission')
        },
        {
          id: 'reception',
          name: this.$t('party_type_meth.reception')
        }
      ],
      dialogCommunicationsMethodsFormCredentials: {
        communicationsmethodsId: null,
        communicationsmethodsPartyId: null,
        user: null,
        password: null
      },
      dialogCommunicationsMethodsForm: {
        communicationsmethodsId: null,
        communicationsmethodsSenderId: 'emission'
      },
      rulesDialogCommunicationsMethodsFormCredentials: {
        communicationsmethodsId: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        communicationsmethodsPartyId: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        user: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { max: 100, message: this.$t('msg_generics.max_num_character', { max: 100 }), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { max: 100, message: this.$t('msg_generics.max_num_character', { max: 100 }), trigger: 'blur' }
        ]

      },
      rulesDialogCommunicationsMethodsForm: {
        communicationsmethodsId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ]
      },
      // CATEGORÍAS DE RECHAZO
      rejectioncategoryData: [],
      currentRowRejectionCategories: [],
      optionsCategory: [],
      optionsVisible: [],
      isShowDialogRejectionCategory: false,
      dialogRejectionCategoriesForm: {
        nameId: null,
        visibleId: null
      },
      rulesDialogRejectionCategoriesForm: {
        nameId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        visibleId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ]
      },

      // TIPOLOGÍA DE COREO
      emailTypeData: [],
      currentRowEmailType: [],
      isShowDialogEmailType: false,
      dialogEmailTypeForm: [],
      optionsEmailType: [],
      emailList: [],
      rulesDialogEmailTypeForm: {
        emailTypeId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        emailValue: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          { validator: validateEmails, trigger: 'click' }
        ]
      },

      // TAREAS PENDIENTES
      pendingtasksData: [],
      currentRowPendingtasks: [],
      optionsStatus: [],
      optionsStatuschange: [],
      isShowDialogPendingtask: false,
      dialogPendingtasksForm: {
        statusId: null,
        statuschangeId: null
      },
      rulesDialogPendingtasksForm: {
        status: [
          { validator: checkAnyStatus, trigger: 'blur' }
        ],
        statuschange: [
          { validator: checkAnyStatus, trigger: 'blur' }
        ]
      },

      // VIGENCIAS
      validities: [],
      currentRowValidities: [],
      isShowDialogValidity: false,
      optionsCountry: [],
      dialogValiditiesForm: {
        validity: null,
        documentType: null,
        country: null,
        role: null
      },
      rulesDialogValiditiesForm: {
        validity: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          { validator: checkIntegerNumber, trigger: 'change' }
        ],
        role: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        documentType: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ]
      },

      // VALIDACIONES
      validationname: null,
      validationValue: null,
      validationsData: [],
      currentRowValidationsData: [],
      isShowDialogValidations: false,
      optionsProjectValidations: [],
      optionsDocumentType: [],

      dialogValidationsForm: {},
      rulesDialogValidationsForm: {
        validationId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        role: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        documentType: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        country: [
          {
            required: false,
            trigger: 'change'
          }
        ],
        documentFormat: [
          {
            required: false,
            trigger: 'change'
          }
        ],
        value: [
          { validator: checkNumber, trigger: 'change' }
        ]
      },

      // PDF
      pdfData: [],
      currentRowPDF: [],
      optionsProjectPDFVisualizations: [],
      isShowDialogPDFVisualizations: false,
      dialogPDFVisualizationsForm: [],
      rulesDialogPDFVisualizationsForm: {
        visualizationId: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        documentType: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ]
      },
      isSelectedDocType: false,

      // INFO
      serviceId: null,
      partyId: null,
      serviceDetailEditForm: {
        // EDITABLES
        name: null,
        enable: null,
        isSender: null,
        logo: null,
        code: null,
        securityCode: null,
        isReceiver: null,
        isIndraProject: null
      },
      formatos: [],
      showComboFormat: false,
      serviceDetailEditFormRules: {
        name: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'blur'
          },
          {
            max: 40,
            message: this.$t('msg_generics.max_num_character', { max: 40 }),
            trigger: 'blur'
          }
        ],

        code: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'blur' },
          { max: 50, message: this.$t('msg_generics.max_num_character', { max: 50 }), trigger: 'blur' },
          { validator: checkcode, trigger: 'change' }
        ],

        securityCode: [
          {
            max: 64,
            message: this.$t('msg_generics.max_num_character', { max: 64 }),
            trigger: 'blur'
          }
        ]
      }
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      // Combos
      'optionsFilterProjectConfiguration',
      'optionsFilterCommunicationsMethods',
      'optionsFilterInvoiceStatus',
      'queryPartiesService',
      // Permisos
      'canModifyProject',
      'canEditProjectDeliveryMethod',
      'canAdminProject',
      'canAdminIndra',
      'primaryColor',
      'countries'
    ])
  },

  methods: {
    ...mapActions([
      'getServiceDetail',
      'addLogoService',
      'getDataConfiguration',
      'removeDataConfiguration',
      'getOptionsFilterProjectConfiguration',
      'addProjectConfiguration',
      'getMimeConfiguration',
      'removeMimeConfiguration',
      'addMimeConfiguration',
      'getCommunicationsMethods',
      'getCommunicationsMethodCredentials',
      'getOptionsFilterPartyMEFenixBackend',
      'queryPartiesServiceState',
      'getCommunicationsMethodsPartyCredentials',
      'getOptionsFilterCommunicationsMethods',
      'getOptionsFilterInvoiceStatus',
      'getOptionsProjectCategory',
      'addCommunicationsMethods',
      'addCommunicationsMethodCredentials',
      'removeCommunicationsMethod',
      'removeCommunicationMethodCredentials',
      'modifyService',
      'downloadLogoService',
      'deleteLogoService',
      'deleteProjectDeliveryNoteType',
      'getValidations',
      'getValidities',
      'getPendingTasks',
      'getRejectionCategories',
      'getOptionsDeliveryNoteType',
      'getProjectDeliveryNoteType',
      'removeProjectValidation',
      'removeProjectValidity',
      'removeProjectPendingTask',
      'removeProjectRejectionCategory',
      'getOptionsDocumentType',
      'insertProjectDeliveryNoteType',
      'addValidation',
      'addValidity',
      'getPDFVisualizations',
      'removeProjectPDFVisualization',
      'addPDFVisualization',
      'getDisplayDocuments',
      'addPendingTask',
      'getEmailTypes',
      'removeProjectMedia',
      'getOptionsEmailType',
      'addProjectEmailType',
      'addRejectionCategory',
      'getFormatByDocType',
      'getPartyDocumentType',
      'getProjectDocFormat',
      'deleteProjectDocumentFormat',
      'getOptionsFilterFormatDocumentType',
      'insertProjectDocumentFormat'
    ]),

    //  Reseteo al cerrar dialogo
    handleCloseDialogDataConfiguration () {
      this.$refs.formDialogDataConfiguration.resetFields()
    },
    handleCloseDialogMimeConfiguration () {
      this.$refs.formDialogMimeConfiguration.resetFields()
    },

    handleCloseDialogProjectDocumentFormat () {
      this.$refs.formDialogAddProjectDocumentFormat.resetFields()
    },

    handleCloseDialogAddProjectDeliveryNoteType () {
      this.$refs.formDialogAddProjectDeliveryNoteType.resetFields()
    },
    validateExtension (filename) {
      return this.extensionFormats.includes('.'.concat((filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)).toLowerCase()))
    },

    handleCellMouseEnterFormat (row, column, cell, event) {
      this.currentRowProjectDocumentFormat = row
    },

    handleCellMouseEnterDeliveryNoteType (row, column, cell, event) {
      this.currentRowAddProjectDeliveryNoteType = row
    },
    async handleCloseDialogCommunicationsMethodsCredentials () {
      this.$refs.formDialogCommunicationsMethodsCredentials.resetFields()
      this.optionsCommunicationsMethodsCredentials = []
      this.optionsSeller = []
      this.showCommunicationUser = false
      this.showCommunicationPass = false
      this.dialogCommunicationsMethodsFormCredentials.user = ''
      this.dialogCommunicationsMethodsFormCredentials.password = ''
    },
    async handleCloseDialogCommunicationsMethods () {
      this.$refs.formDialogCommunicationsMethods.resetFields()
      this.hasCredentials = false
      this.dialogCommunicationsMethodsForm.communicationsmethodsSenderId = 'emission'
      // await this.getFilterMethodsCommunications()
      // Combo final métodos de comunicación
      this.getMethodsCommunications()
    },

    handleCloseDialogValidations () {
      this.$refs.formDialogValidations.resetFields()
    },

    handleCloseDialogPDFVisualizations () {
      this.$refs.formDialogPDFVisualizations.resetFields()
    },

    handleCloseDialogValidities () {
      this.$refs.formDialogValidities.resetFields()
    },
    handleCloseDialogPendingtasks () {
      this.$refs.formDialogPendingtasks.resetFields()
    },
    handleCloseDialogRejectionCategories () {
      this.$refs.formDialogRejectionCategories.resetFields()
    },

    handleCloseDialogEmailType () {
      this.$refs.formDialogEmailType.resetFields()
    },

    /* Redirige a las empresas de un servicio */
    handleGoParties () {
      sessionStorage.setItem('projectName', this.serviceDetailEditForm.name)

      router.push({
        name: 'servicios-empresas-page',
        params: {
          projectId: this.$route.params.projectId,
          projectName: this.serviceDetailEditForm.name
        }
      })
    },

    inicializecode () {
      this.serviceDetailEditForm.code = 'FNX-0000-' + this.serviceDetailEditForm.name.toUpperCase()
      this.codeModified = false
    },
    formatterDeliveryNoteType (docType) {
      if (docType.deliveryNoteTypeCode === null) {
        return this.$t('delivery_note_type.NO_LOGISTIC')
      } else if (docType.deliveryNoteTypeCode) {
        return this.$t('delivery_note_type.' + docType.deliveryNoteTypeCode)
      }
    },
    formatterRole (row, column) {
      if (row.sender === true) {
        return this.$t('projects.validities.emission')
      } else if (row.sender === false) {
        return this.$t('projects.validities.reception')
      } else {
        return this.$t('project_type.both')
      }
    },

    formatterDirection (row, column) {
      if (row.issueDirection === true) {
        return this.$t('projects.validities.emission')
      } else if (row.issueDirection === false) {
        return this.$t('projects.validities.reception')
      } else {
        return this.$t('project_type.both')
      }
    },

    formatterName (row, column) {
      return this.replaceValidationPoints(row.name)
    },

    formatterEmailType (row, column) {
      return this.$t('email_type.' + row.type)
    },

    formatterVisualizationName (row, column) {
      return this.$t('display_documents.' + row.name)
    },

    replaceValidationPoints (val) {
      const validationsFormat = val.split('.').join('_')
      return this.$t('validations.data.' + validationsFormat)
    },

    formatterSenderType (row, column) {
      if (row[column.property] == null) {
        return this.$t('party_type_meth.both')
      } else if (row[column.property]) {
        return this.$t('party_type_meth.emission')
      } else if (!row[column.property]) {
        return this.$t('party_type_meth.reception')
      }
    },
    formatterDeliveryMethods (row, column) {
      if (row[column.property]) {
        return this.$t('communication_method.' + row[column.property])
      }
    },
    formatterCountry (row, column) {
      if (row[column.property]) {
        return this.$t('countries.country_' + row[column.property])
      }
    },

    formatterDocumentType (row, column) {
      if (row[column.property]) {
        return this.$t('auditory_doc_type.' + row[column.property])
      }
    },
    formatterConfiguration (row, column) {
      if (row[column.property]) {
        return this.$t('configuration_table.' + row[column.property])
      }
    },
    formatterStatus (row, column) {
      if (row[column.property]) {
        return this.$t('invoice_status.' + row[column.property])
      }
    },
    formatterModule (row, column) {
      if (row[column.property]) {
        return this.$t('module.' + row[column.property])
      }
    },
    formatterVisible (row, column) {
      if (row[column.property] != null && row[column.property]) {
        return this.$t('msg_generics.question.yes')
      } else {
        return this.$t('msg_generics.question.no')
      }
    },
    formatterCategory  (row, column) {
      if (row[column.property]) {
        return this.$t('categories.' + row[column.property])
      }
    },
    // Metodos de modificación del LOGO
    onSubmitAddLogo (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.upload_logo')
          })
          try {
            console.log('submit!!!   ', this.fileList)
            await this.addLogoService({
              logo: this.fileList[0],
              serviceId: this.serviceId
            })
            this.$notify({
              title: this.$t('msg_generics.upload_attachment_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            await this.getServiceOnDatabase()
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            this.$refs[formName].resetFields()
            this.isShowDialogAddLogo = false
            load.close()
          }
        } else {
          console.log('error submit!!!!')
          return false
        }
      })
    },

    //* *Elimina el logo del proyecto */
    async removeLogo () {
      console.log('removeLogo...')
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_logo')
      })
      try {
        await this.deleteLogoService({
          serviceId: this.serviceId
        })
        await this.getServiceOnDatabase()
        this.$notify({
          title: this.$t('project_detail.notify.delete_logo'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Elimina un tipo de albaran asociado al proyecto
    async removeProjectDeliveryNoteType () {
      // Necesita el permiso canAdminIndra para poder eliminar elementos
      if (this.canAdminProject) {
        const load = this.$loading({
          lock: true,
          text: this.$t('project_detail.load.delete_project_delivery_note_type')
        })
        try {
          await this.deleteProjectDeliveryNoteType({
            serviceId: this.serviceId,
            deliveryNoteTypeId: this.currentRowAddProjectDeliveryNoteType.deliveryNoteTypeId
          })
          // Actualizamos vista tabla con los registros tras el borrado
          this.getProjectDeliveryNoteTypeOnDatabase()
          this.$notify({
            title: this.$t('project_detail.notify.delete_project_delivery_note_type'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // INSERTAR NUEVO TIPO DE ALBARAN
    async addProjectDeliveryNoteType (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_project_delivery_note_type')
          })
          try {
            const params = {
              serviceId: this.serviceId,
              deliveryNoteTypeId: this.dialogAddProjectDeliveryNoteTypeForm.deliveryNoteTypeId

            }
            console.log('addProjectDeliveryNoteType params: ', params)
            await this.insertProjectDeliveryNoteType(params)
            this.$notify({
              title: this.$t('project_detail.notify.add_project_delivery_note_type'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            await this.getProjectDeliveryNoteTypeOnDatabase()
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogAddProjectDeliveryNoteType = false
          }
        } else {
          console.log('addProjectDeliveryNoteType INVALID: ', this.dialogAddProjectDeliveryNoteTypeForm)
        }
      })
    },

    // TIPOS DE ALBARAN ASOCIADOS AL PROYECTO
    async getProjectDeliveryNoteTypeOnDatabase () {
      // Get datos de tipos de albaranes
      try {
        const response = await this.getProjectDeliveryNoteType({
          serviceId: this.serviceId,
          projectId: this.projectId
        })
        this.projectDeliveryNoteType = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    //* * Descarga el logo del proyecto */
    async downloadLogo () {
      console.log('downloadLogo...')
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.download_logo')
      })
      try {
        await this.downloadLogoService({
          serviceId: this.serviceId
        })
        this.$notify({
          title: this.$t('msg_generics.download_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.formDialogAddLogo.fichero = file
      this.$refs.formDialogAddLogo.validateField('fichero')
    },

    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('fichero')
      this.fileList = []
    },

    // Reseteo al cerrar dialogo de añadir logo
    handleCloseDialogAddLogo () {
      this.$refs.formDialogAddLogo.resetFields()
      this.fileList = []
    },

    /** Guarda los cambios del proyecto */
    saveService (formName) {
      const self = this
      this.$refs[formName].validate(async valid => {
        if (valid) {
          console.log('saveService: ', self.serviceDetailEditForm)
          const load = self.$loading({
            lock: true,
            text: this.$t('project_detail.load.save_changes')
          })
          try {
            const request = {
              serviceId: this.serviceId,
              params: {
                name: self.serviceDetailEditForm.name,
                enable: self.serviceDetailEditForm.enable,
                isSender: self.serviceDetailEditForm.isSender,
                code: self.serviceDetailEditForm.code.toUpperCase(),
                securityCode: self.serviceDetailEditForm.securityCode,
                isReceiver: self.serviceDetailEditForm.isReceiver,
                isIndraProject: self.serviceDetailEditForm.isIndraProject,
                facturar: self.serviceDetailEditForm.facturar
              }
            }
            const response = await self.modifyService(request)
            if (!response.facturar) {
              this.serviceDetailEditForm.facturar = 'Fenix'
            }
            self.serviceDetailEditForm = response.data
            await this.getDataConfigurationOnDatabase()
            self.$notify({
              title: this.$t('project_detail.notify.save_changes'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            self.getNotificationErrorMessage(error)
          } finally {
            self.loadComboProjectConfigurationType()
            load.close()
          }
        } else {
          console.log(
            'submitServiceDetailEditForm: ',
            self.serviceDetailEditForm
          )
        }
      })
    },

    async cancelServiceDetailEditForm () {
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.cancel')
      })
      try {
        // Quitamos el foco del boton
        this.$refs.buttonCancel.$el.blur()
        await this.getServiceOnDatabase()
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // TIPO DE DOCUMENTOS Documentos y formatos emiten o reciben
    async getProjectDocumentTypeOnDatabase () {
      // Get datos de formatos de documentos
      try {
        const response = await this.getPartyDocumentType()
        this.projectDocumentType = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Documentos y formatos emiten o reciben
    async getProjectDocumentFormatOnDatabase () {
      // Get datos de formatos de documentos
      try {
        const response = await this.getProjectDocFormat({
          serviceId: this.serviceId,
          partyId: this.partyId
        })
        this.projectDocumentFormat = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Elimina Documentos y formatos emiten o reciben
    async removeProjectDocumentFormat () {
      // Necesita el permiso canAdminIndra para poder eliminar elementos
      if (this.canAdminProject) {
        const load = this.$loading({
          lock: true,
          text: this.$t('project_detail.load.delete_project_document_format')
        })
        try {
          await this.deleteProjectDocumentFormat({
            serviceId: this.serviceId,
            projectDocumentFormatId: this.currentRowProjectDocumentFormat.id
          })
          // Actualizamos vista tabla con los registros tras el borrado
          this.getProjectDocumentFormatOnDatabase()
          this.$notify({
            title: this.$t('project_detail.notify.delete_project_document_format'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    async onChangeSelection () {
      this.dialogProjectDocumentFormatForm.documentFormat = null
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        this.projectDocumentFormatByType = await this.getOptionsFilterFormatDocumentType(this.dialogProjectDocumentFormatForm.documentType)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // INSERTAR Documentos y formatos emiten o reciben
    async addProjectDocumentFormat (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_document_format')
          })
          try {
            const params = {
              serviceId: this.serviceId,
              projectDocumentFormat: this.dialogProjectDocumentFormatForm
            }
            console.log('addProjectDocumentFormat params: ', params)
            await this.insertProjectDocumentFormat(params)
            this.$notify({
              title: this.$t('project_detail.notify.add_document_format'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            await this.getProjectDocumentFormatOnDatabase()
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogProjectDocumentFormat = false
          }
        } else {
          console.log('addProjectDocumentFormat INVALID: ', this.dialogProjectDocumentFormatForm)
        }
      })
    },

    async getServiceOnDatabase () {
      try {
        const response = await this.getServiceDetail(this.serviceId)
        this.serviceDetailEditForm = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    showUploadDialog (event) {
      this.isShowDialogAddLogo = true
      if (event) event.preventDefault()
    },

    selectFile (event) {
      if (event) event.preventDefault()
    },

    // DATOS DE CONFIGURACION
    async getDataConfigurationOnDatabase () {
      // Get datos de configuracion
      try {
        const data = await this.getDataConfiguration(this.serviceId)
        this.dataconfiguration = data
        for (let index = 0; index < this.dataconfiguration.length; index++) {
          if (this.dataconfiguration[index].asBuyer && !this.dataconfiguration[index].asSeller) {
            this.dataconfiguration[index].typeText = this.$t('project_type.buyer')
          } else if (!this.dataconfiguration[index].asBuyer && this.dataconfiguration[index].asSeller) {
            this.dataconfiguration[index].typeText = this.$t('project_type.seller')
          } else if (this.dataconfiguration[index].asBuyer && this.dataconfiguration[index].asSeller) {
            this.dataconfiguration[index].typeText = this.$t('project_type.both')
          }
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRowDataconfiguration = row
    },

    // DATOS DE CONFIGURACION MIME
    async getMimeConfigurationOnDatabase () {
      // Get datos de configuracion
      try {
        const data = await this.getMimeConfiguration(this.serviceId)
        this.mimeconfiguration = data
        console.log('data', data)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    handleMimeCellMouseEnter (row, column, cell, event) {
      this.currentRowMimeconfiguration = row
    },

    handleCellMouseEnterMethod (row, column, cell, event) {
      this.currentRowProjectMethod = row
    },

    handleCredentialsCellMouseEnter (row, column, cell, event) {
      this.currentRowPartyMethod = row
    },

    handleValidationCellMouseEnter (row, column, cell, event) {
      this.currentRowValidationsData = row
    },

    handleValidityCellMouseEnter (row, column, cell, event) {
      this.currentRowValidities = row
    },
    handlePDFCellMouseEnter (row, column, cell, event) {
      this.currentRowPDF = row
    },
    handlePendingtasksCellMouseEnter (row, column, cell, event) {
      this.currentRowPendingtasks = row
    },
    handleRejectionCategoryCellMouseEnter (row, column, cell, event) {
      this.currentRowRejectionCategories = row
    },
    handleEmailTypeCellMouseEnter (row, column, cell, event) {
      this.currentRowEmailType = row
    },
    //* * Elimina un data_configuration */
    async removeDataConf () {
      console.log('removeDataConfiguration: ', this.serviceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_configuration')
      })
      try {
        await this.removeDataConfiguration({
          serviceId: this.serviceId,
          dataconfigurationId: this.currentRowDataconfiguration.configurationId
        })
        await this.getDataConfigurationOnDatabase()
        this.$notify({
          title: this.$t('project_detail.notify.delete_configuration'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    //* * Crea el combo de tipo de configuración */
    loadComboProjectConfigurationType () {
      this.comboTypeList = []
      if (this.serviceDetailEditForm.isSender) {
        this.comboTypeList.push({ code: 'AS_SELLER', description: this.$t('project_type.seller') })
      }
      if (this.serviceDetailEditForm.isReceiver) {
        this.comboTypeList.push({ code: 'AS_BUYER', description: this.$t('project_type.buyer') })
      }
      if (
        this.serviceDetailEditForm.isSender &&
        this.serviceDetailEditForm.isReceiver
      ) {
        this.comboTypeList.push({ code: 'BOTH', description: this.$t('project_type.both') })
      }
    },
    //* * Elimina un mime_configuration */
    async removeMimeConf () {
      console.log('removeMimeConfiguration: ', this.serviceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_configuration')
      })
      try {
        await this.removeMimeConfiguration({
          serviceId: this.serviceId,
          dataconfigurationMimeId: this.currentRowMimeconfiguration.id
        })
        await this.getMimeConfigurationOnDatabase()
        this.$notify({
          title: this.$t('project_detail.notify.delete_configuration'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    //* * Inserta un mime_configuration */
    onSubmitAddMimeConfiguration (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_configuration')
          })
          try {
            console.log(
              'onSubmitAddMimeConfiguration VALID: ',
              this.dialogMimeConfigurationForm
            )
            const params = {
              serviceId: this.serviceId,
              mimeFrom: this.dialogMimeConfigurationForm.mimeFrom,
              mimeSender: this.dialogMimeConfigurationForm.mimeSender,
              mimeReplyTo: this.dialogMimeConfigurationForm.mimeReplyTo
            }
            await this.addMimeConfiguration(params)
            await this.getMimeConfigurationOnDatabase()

            this.$notify({
              title: this.$t('project_detail.notify.add_configuration'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogMimeConfiguration = false
          }
        } else {
          console.log(
            'onSubmitAddMimeConfiguration INVALID: ',
            this.dialogMimeConfigurationForm
          )
          return false
        }
      })
    },

    //* * Crea el combo de Roles de vigencia */
    loadComboValidityRoleType () {
      this.comboRoleList = []
      this.comboRoleList.push({ code: 'AS_SELLER', description: this.$t('projects.validities.emission') })
      this.comboRoleList.push({ code: 'AS_BUYER', description: this.$t('projects.validities.reception') })
      // por defecto mostrará emisión
    },
    //* * Crea el combo de Roles de validacion */
    loadComboValidationRoleType () {
      this.comboValidationRoleList = []
      this.comboValidationRoleList.push({ code: 'AS_SELLER', description: this.$t('projects.validities.emission') })
      this.comboValidationRoleList.push({ code: 'AS_BUYER', description: this.$t('projects.validities.reception') })
      this.comboValidationRoleList.push({ code: 'BOTH', description: this.$t('project_type.both') })
      // por defecto mostrará emisión
      this.dialogValidationsForm.role = 'AS_SELLER'
    },
    //* * Crea el combo de dirección de Pdf */
    loadComboDirectioinPdfType () {
      this.comboDirectionList = []
      this.comboDirectionList.push({ code: true, description: this.$t('projects.validities.emission') })
      this.comboDirectionList.push({ code: false, description: this.$t('projects.validities.reception') })
      this.comboDirectionList.push({ code: null, description: this.$t('project_type.both') })
      // por defecto mostrará emisión
      this.dialogPDFVisualizationsForm.issueDirection = true
    },

    //* * Inserta un data_configuration */
    onSubmitAddDataConfiguration (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_configuration')
          })
          try {
            console.log(
              'onSubmitAddDataConfiguration VALID: ',
              this.dialogDataConfigurationForm
            )
            const params = {
              serviceId: this.serviceId,
              configurationId: this.dialogDataConfigurationForm.configurationId,
              type: this.dialogDataConfigurationForm.type,
              value: this.dialogDataConfigurationForm.value
            }
            await this.addProjectConfiguration(params)
            await this.getDataConfigurationOnDatabase()

            this.$notify({
              title: this.$t('project_detail.notify.add_configuration'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogDataConfiguration = false
          }
        } else {
          console.log(
            'onSubmitAddDataConfiguration INVALID: ',
            this.dialogDataConfigurationForm
          )
          return false
        }
      })
    },

    async onSubmitAddValidation (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_validation')
          })
          try {
            if (this.formatos.length === 0) {
              this.dialogValidationsForm.documentFormat = null
            }
            const params = {
              serviceId: this.serviceId,
              validationId: this.dialogValidationsForm.validationId,
              value: this.validationValue,
              role: this.dialogValidationsForm.role,
              documentType: this.dialogValidationsForm.documentType,
              documentFormat: this.dialogValidationsForm.documentFormat,
              country: this.dialogValidationsForm.country
            }
            await this.addValidation(params)
            await this.getValidationsOnDatabase(true)

            this.$notify({
              title: this.$t('project_detail.notify.add_validation'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogValidations = false
          }
        }
      })
    },

    async onSubmitAddEmailProjectType (formName) {
      this.emailList = []
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_emailType')
          })
          try {
            const params = {
              serviceId: this.serviceId,
              emailTypeId: this.dialogEmailTypeForm.emailTypeId,
              emailValue: this.emailList
            }
            await this.addProjectEmailType(params)
            await this.getEmailTypeByProjectOnDatabase()

            this.$notify({
              title: this.$t('project_detail.notify.add_emailType'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogEmailType = false
          }
        }
      })
    },

    async onSubmitAddPDFVisualization (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_visualization')
          })
          try {
            const params = {
              serviceId: this.serviceId,
              visualizationId: this.dialogPDFVisualizationsForm.visualizationId,
              documentType: this.dialogPDFVisualizationsForm.documentType,
              issueDirection: this.dialogPDFVisualizationsForm.issueDirection,
              communicationsmethodsId: this.dialogPDFVisualizationsForm.communicationsmethodsId
            }
            await this.addPDFVisualization(params)
            await this.getPDFVisualizationsOnDatabase()

            this.$notify({
              title: this.$t('project_detail.notify.add_PDFVisualization'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogPDFVisualizations = false
          }
        }
      })
    },

    async onSubmitAddValidity (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_validity')
          })
          try {
            const params = {
              serviceId: this.serviceId,
              validity: this.dialogValiditiesForm.validity,
              country: this.dialogValiditiesForm.country,
              role: this.dialogValiditiesForm.role,
              documentType: this.dialogValiditiesForm.documentType
            }
            await this.addValidity(params)
            await this.getvaliditiesOnDatabase()

            this.$notify({
              title: this.$t('project_detail.notify.add_validity'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogValidity = false
          }
        }
      })
    },

    async changeProjectRole () {
      this.$notify({
        title: this.$t('msg_generics.alter_configuration'),
        type: 'warning',
        position: 'top-right',
        customClass: 'b2b-notification-success',
        duration: 10000
      })
      await this.getCommunicationsMethodsOnDatabase()
    },

    // METODOS DE ENTREGA
    async getCommunicationsMethodsOnDatabase () {
      // Get datos de metodo de entrgega
      try {
        let response = await this.getCommunicationsMethods({
          serviceId: this.serviceId,
          sender: 'ALL'
        })
        if (this.serviceDetailEditForm.isSender && !this.serviceDetailEditForm.isReceiver) {
          response = await this.getCommunicationsMethods({
            serviceId: this.serviceId,
            sender: 'SENDER'
          })
        } else if (!this.serviceDetailEditForm.isSender && this.serviceDetailEditForm.isReceiver) {
          response = await this.getCommunicationsMethods({
            serviceId: this.serviceId,
            sender: 'RECEIVER'
          })
        }
        this.communicationsmethods = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async getCommunicationsMethodCredentialsOnDatabase () {
      // Get datos de metodo de entrgega
      try {
        const response = await this.getCommunicationsMethodCredentials({
          serviceId: this.serviceId,
          sender: 'ALL'
        })

        this.communicationsmethodCredentials = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // METODOS DE ENTREGA del servicio con credenciales
    async getCommunicationsMethodsToPartyCredentials () {
      // Get datos de metodo de entrgega
      try {
        const response = await this.getCommunicationsMethodsPartyCredentials({
          serviceId: this.serviceId,
          idPartySender: this.partyId,
          credentials: true,
          sender: 'ALL'
        })
        this.optionsCommunicationsMethodsCredentials = response
        console.log('response:', response)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    /**
     * Categorías de rechazo
     */
    async getRejectionCategoriesOnDatabase () {
      try {
        const dataQuery = {
          serviceId: this.serviceId
        }
        const response = await this.getRejectionCategories(dataQuery)
        this.rejectioncategoryData = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async removeRejectionCategory () {
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_rejectionCategory')
      })
      try {
        await this.removeProjectRejectionCategory({
          serviceId: this.serviceId,
          categoryId: this.currentRowRejectionCategories.id
        })
        await this.getRejectionCategoriesOnDatabase()
        this.$notify({
          title: this.$t('project_detail.notify.delete_rejectionCategory'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async removeEmailType () {
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_emailType')
      })
      try {
        await this.removeProjectMedia({
          serviceId: this.serviceId,
          projectMediaId: this.currentRowEmailType.id
        })
        await this.getEmailTypeByProjectOnDatabase()
        this.$notify({
          title: this.$t('project_detail.notify.delete_emailType'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async openDialogAddRejectionCategory () {
      this.optionsCategory = []
      this.optionsVisible = [
        { id: 'yes', code: this.$t('msg_generics.question.yes') },
        { id: 'no', code: this.$t('msg_generics.question.no') }
      ]
      this.dialogRejectionCategoriesForm = {}
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.add_rejectionCategory')
      })
      this.optionsCategory = await this.getOptionsProjectCategory(this.serviceId)
      load.close()
      this.isShowDialogRejectionCategory = true
    },

    async openDialogAddEmailType () {
      this.optionsEmailType = []
      this.dialogEmailTypeForm = {}
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.add_validation')
      })
      this.optionsEmailType = await this.getOptionsEmailType()
      await this.getEmailTypeByProjectOnDatabase()
      load.close()
      this.isShowDialogEmailType = true
    },

    async onSubmitAddRejectionCategory (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_rejectionCategory')
          })
          try {
            const params = {
              serviceId: this.serviceId,
              categoryId: this.dialogRejectionCategoriesForm.nameId,
              visibleId: this.dialogRejectionCategoriesForm.visibleId
            }
            await this.addRejectionCategory(params)
            await this.getRejectionCategoriesOnDatabase()

            this.$notify({
              title: this.$t('project_detail.notify.add_rejectionCategory'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            this.isShowDialogRejectionCategory = false
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
          }
        } else {
          console.log(
            'onSubmitAddRejectionCategories INVALID: ',
            this.dialogRejectionCategoriesForm
          )
          return false
        }
      })
    },

    /**
     * TAREAS PENDIENTES
     */
    async getpendingTasksOnDatabase () {
      try {
        const dataQuery = {
          serviceId: this.serviceId
        }
        const response = await this.getPendingTasks(dataQuery)
        this.pendingtasksData = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    // Elimina un estado de tarea pendiente
    async removePendingTask () {
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_pendingtask')
      })
      try {
        await this.removeProjectPendingTask({
          serviceId: this.serviceId,
          pendingtaskId: this.currentRowPendingtasks.id
        })
        await this.getpendingTasksOnDatabase()
        this.$notify({
          title: this.$t('project_detail.notify.delete_pendingtask'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    /**
    * VIGENCIAS
    */
    async getvaliditiesOnDatabase () {
      try {
        const dataQuery = {
          serviceId: this.serviceId
        }
        const response = await this.getValidities(dataQuery)
        this.validities = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async onSubmitAddPendingtasks (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_pendingtask')
          })
          try {
            if (!this.dialogPendingtasksForm.statuschangeId) {
              this.dialogPendingtasksForm.statuschangeId = null
            }
            if (!this.dialogPendingtasksForm.statusId) {
              this.dialogPendingtasksForm.statusId = null
            }

            const params = {
              serviceId: this.serviceId,
              status: this.dialogPendingtasksForm.statusId,
              statuschange: this.dialogPendingtasksForm.statuschangeId
            }
            await this.addPendingTask(params)
            await this.getpendingTasksOnDatabase()

            this.$notify({
              title: this.$t('project_detail.notify.add_pendingtask'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            this.isShowDialogPendingtask = false
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
          }
        } else {
          console.log(
            'onSubmitAddPendingtasks INVALID: ',
            this.dialogPendingtasksForm
          )
          return false
        }
      })
    },

    // Elimina una vigencia
    async removeValidity () {
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_validity')
      })
      try {
        await this.removeProjectValidity({
          serviceId: this.serviceId,
          validityId: this.currentRowValidities.id
        })
        await this.getvaliditiesOnDatabase()
        this.$notify({
          title: this.$t('project_detail.notify.delete_validity'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async chargeDialogAddValidity () {
      this.optionsDocumentType = []
      this.dialogValiditiesForm = {}
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.add_validity')
      })
      await this.getDocumentTypeSorted()
      load.close()
    },

    async getDocumentTypeSorted () {
      const response = await this.getOptionsDocumentType()
      for (let index = 0; index < response.length; index++) {
        response[index].code = this.$t('auditory_doc_type.' + response[index].code)
      }
      response.sort((a, b) => (a.code.toUpperCase().localeCompare(b.code.toUpperCase())))
      this.optionsDocumentType = response
    },
    /*
    * VALIDACIONES
    * enable: true si queremos obtener las validaciones activaspara ese proyecto
    * enable:false si queremos obtener las validaciones que no están activas para el proyecto
    */
    async getValidationsOnDatabase (enable) {
      try {
        const dataQuery = {
          serviceId: this.serviceId,
          enable: enable
        }
        const response = await this.getValidations(dataQuery)
        if (enable === null || enable === true) {
          this.validationsData = response
        } else {
          for (let index = 0; index < response.length; index++) {
            response[index].name = this.$t('validations.data.' + response[index].name.split('.').join('_'))
          }
          // ordenamos las validaciones por el nombre traducido
          response.sort((a, b) => (a.name.toUpperCase().localeCompare(b.name.toUpperCase())))

          this.optionsProjectValidations = response
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    async getPDFVisualizationsOnDatabase () {
      try {
        const dataQuery = {
          serviceId: this.serviceId
        }
        const response = await this.getPDFVisualizations(dataQuery)
        this.pdfData = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async getEmailTypeByProjectOnDatabase () {
      try {
        const dataQuery = {
          serviceId: this.serviceId
        }
        const response = await this.getEmailTypes(dataQuery)
        this.emailTypeData = response
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async openDialogAddPendingTask () {
      this.optionsStatus = []
      this.optionsStatuschange = []
      this.dialogPendingtasksForm = {}
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.add_pendingtask')
      })
      const paramstatus = {
        module: 'PENDING_TASKS',
        projectId: this.serviceId
      }
      const response = await this.getOptionsFilterInvoiceStatus(paramstatus)

      for (let index = 0; index < response.length; index++) {
        response[index].code = this.$t('invoice_status.' + response[index].code)
      }
      // ordenamos los estados por el nombre traducido
      response.sort((a, b) => (a.code.toUpperCase().localeCompare(b.code.toUpperCase())))
      this.optionsStatus = response

      const paramschangetatus = {
        module: 'PENDING_TASKS_CHANGE_STATUS',
        projectId: this.serviceId
      }

      const responsechange = await this.getOptionsFilterInvoiceStatus(paramschangetatus)
      for (let index = 0; index < responsechange.length; index++) {
        responsechange[index].code = this.$t('invoice_status.' + responsechange[index].code)
      }
      // ordenamos los estados por el nombre traducido
      responsechange.sort((a, b) => (a.code.toUpperCase().localeCompare(b.code.toUpperCase())))
      this.optionsStatuschange = responsechange

      load.close()
      this.isShowDialogPendingtask = true
    },
    async openDialogDeliveryMehodsCredentials () {
      this.isShowDialogDeliveryMehodsCredentials = true
    },

    async filterPartiesSeller (data) {
      // Solo filtraremos por vendedor si previamente se a seleccionado servicio
      if (this.serviceId) {
        try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
          if (data.length >= 3) {
            clearTimeout(this.tid)
            this.tid = setTimeout(this.getSellerResults, 1000, data)
          // Si el valor introducido tiene más de 3 caracteres, se filtra en la propia lista obtenida anteriormente
          } else {
            this.optionsSeller = []
            this.auxListPartiesSeller = []
          }
        } catch (error) {
          console.log('filterPartiesSeller CATCH: ', error)
          this.getNotificationErrorMessage(error)
        }
      }
    },
    async getSellerResults (data) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      const dataQuerySeller = {
        role: 'SELLER',
        appFrom: 'B2bPageServicio',
        emission: true,
        seller: true,
        sponsor: true,
        page: 0,
        size: 1000,
        // enabled: true,
        projectId: [this.serviceId],
        tradeNameOrTaxId: data
      }
      try {
        const response = await this.getOptionsFilterPartyMEFenixBackend(dataQuerySeller)
        this.auxListPartiesSeller = response
        this.optionsSeller = response
      } catch (error) {
        console.log('filterPartiesSeller CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async openDialogDeliveryMehods () {
      this.isShowDialogDeliveryMehods = true

      // Combo método de comunicación
      await this.getFilterMethodsCommunications()
      // Combo final métodos de comunicación
      this.getMethodsCommunications()
    },
    async openDialogAddValidation () {
      this.optionsDocumentType = []
      this.dialogValidationsForm = {}
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.add_validation')
      })
      await this.getDocumentTypeSorted()
      await this.getValidationsOnDatabase(false)
      load.close()
      this.isShowDialogValidations = true
    },
    async openDialogAddPDFVisualization () {
      this.optionsDocumentType = []
      this.isSelectedDocType = false
      this.dialogPDFVisualizationsForm = {}
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.add_visualization')
      })
      await this.getDocumentTypeSorted()
      await this.getPDFVisualizationsOnDatabase()
      load.close()
      this.isShowDialogPDFVisualizations = true
    },
    async getFilterMethodsCommunications () {
      this.showCommunicationFilter = false
      if (this.serviceDetailEditForm.isSender && !this.serviceDetailEditForm.isReceiver) {
        await this.getOptionsFilterCommunicationsMethods('SENDER')
      } else if (!this.serviceDetailEditForm.isSender && this.serviceDetailEditForm.isReceiver) {
        await this.getOptionsFilterCommunicationsMethods('RECEIVER')
      } else if (this.serviceDetailEditForm.isSender && this.serviceDetailEditForm.isReceiver) {
        this.showCommunicationFilter = true
        await this.getOptionsFilterCommunicationsMethods('SENDER')
      }
    },
    onChangeCommunicationsCredentials (data) {
      if (data) {
        this.dialogCommunicationsMethodsFormCredentials.communicationsmethodsId = data
        this.dialogCommunicationsMethodsFormCredentials.user = ''
        this.dialogCommunicationsMethodsFormCredentials.password = ''
        this.showCommunicationUser = true
        this.showCommunicationPass = true
      }
    },
    async onChangeCommunicationsParty (data) {
      this.optionsCommunicationsMethodsCredentials = []
      this.dialogCommunicationsMethodsFormCredentials.communicationsmethodsId = null
      this.showCommunicationUser = false
      this.showCommunicationPass = false
      this.dialogCommunicationsMethodsFormCredentials.user = ''
      this.dialogCommunicationsMethodsFormCredentials.password = ''
      this.partyId = data
      await this.getCommunicationsMethodsToPartyCredentials()
    },
    onChangeCommunicationsSender (data) {
      this.dialogCommunicationsMethodsForm.optionsFilterCommunicationsMethods = []
      this.dialogCommunicationsMethodsForm.communicationsmethodsId = null
      this.getCommunicationsMethodSender(data, true)
    },
    onChangeValidation (data) {
      this.validationname = null
      this.validationValue = null
      const opt = this.optionsProjectValidations.find(function (c) {
        return c.idBusinessValidation === data
      })
      if (opt) {
        this.validationname = opt.name
      }
    },
    async onChangeDocumentType (data) {
      this.formatos = await this.getFormatByDocType(data)
      if (this.formatos.length > 0) {
        this.showComboFormat = true
      } else {
        this.showComboFormat = false
      }
    },
    async getDisplayDocumentsByDocumentType (data) {
      const dataQuery = {
        documentTypeId: data
      }
      this.optionsProjectPDFVisualizations = await this.getDisplayDocuments(dataQuery)
      if (this.optionsProjectPDFVisualizations.length > 0) {
        this.isSelectedDocType = true
      } else {
        this.$notify({
          title: this.$t('project_detail.notify.noDisplayDocuments'),
          type: 'info',
          position: 'top-right',
          customClass: 'b2b-notification-info'
        })
      }
    },

    async getCommunicationsMethodSender (data, isChanged) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const opt = this.optionsCommunicationsMethodsSender.find(function (c) {
          return c.id === data
        })
        if (opt.id === 'emission') {
          await this.getOptionsFilterCommunicationsMethods('SENDER')
        } else {
          await this.getOptionsFilterCommunicationsMethods('RECEIVER')
        }
        // Combo final métodos de comunicación
        this.getMethodsCommunications()
      } finally {
        load.close()
      }
    },
    getMethodsCommunications () {
      try {
        for (let x = 0; x < this.optionsFilterCommunicationsMethods.length; x++) {
          for (const y in this.communicationsmethods) {
            if (this.optionsFilterCommunicationsMethods[x].name === this.communicationsmethods[y].name) {
              // - console.log(  '@@@REPETIDO' + this.optionsFilterCommunicationsMethods[x].name  )
              this.optionsFilterCommunicationsMethods.splice(x, 1)
              if (x >= 0) {
                x--
              }
              break
            }
          }
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },
    addCommunicationsMethodsCredentials (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_delivery_method')
          })
          try {
            console.log(
              'addCommunicationsMethodsCredentials: ',
              this.dialogCommunicationsMethodsFormCredentials
            )
            const params = {
              serviceId: this.serviceId,
              idPartySender: this.partyId,
              communicationsmethodsId: this.dialogCommunicationsMethodsFormCredentials
                .communicationsmethodsId,
              user: this.dialogCommunicationsMethodsFormCredentials.user.trim(),
              password: this.dialogCommunicationsMethodsFormCredentials.password.trim()
            }
            await this.addCommunicationsMethodCredentials(params)
            await this.getCommunicationsMethodCredentialsOnDatabase()
            this.$notify({
              title: this.$t('project_detail.notify.add_delivery_method'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogDeliveryMehodsCredentials = false
            this.showCommunicationUser = false
            this.showCommunicationPass = false
          }
        } else {
          console.log(
            'addCommunicationsMethodsCredentials INVALID: ',
            this.dialogCommunicationsMethodsFormCredentials
          )
          return false
        }
      })
    },

    //* * Inserta un método de entrega */
    onSubmitAddCommunicationsMethods (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('project_detail.load.add_delivery_method')
          })
          try {
            console.log(
              'onSubmitAddCommunicationsMethods VALID: ',
              this.dialogCommunicationsMethodsForm
            )
            const params = {
              serviceId: this.serviceId,
              communicationsmethodsId: this.dialogCommunicationsMethodsForm
                .communicationsmethodsId
            }
            await this.addCommunicationsMethods(params)
            await this.getCommunicationsMethodsOnDatabase()
            // Cargamos en la tabla las credenciales por si cambian
            await this.getCommunicationsMethodCredentialsOnDatabase()
            // Combo final métodos de comunicación
            this.getMethodsCommunications()
            this.$notify({
              title: this.$t('project_detail.notify.add_delivery_method'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
            this.$refs[formName].resetFields()
            this.isShowDialogDeliveryMehods = false
          }
        } else {
          console.log(
            'onSubmitAddCommunicationsMethods INVALID: ',
            this.dialogCommunicationsMethodsForm
          )
          return false
        }
      })
    },
    async removeCommunicationsMethodCredentials (communicationsMethods) {
      // Necesita el permiso PROJEC_DELIVERY_METHOD para poder eliminar elementos
      if (this.canEditProjectDeliveryMethod) {
        console.log('removeCommunicationsMethodCredentials: ', this.currentRowPartyMethod.id)
        const load = this.$loading({
          lock: true,
          text: this.$t('project_detail.load.delete_delivery_method')
        })
        try {
          await this.removeCommunicationMethodCredentials({
            serviceId: this.serviceId,
            communicationsmethodsId: this.currentRowPartyMethod.id
          })
          // Cargamos en la tabla los metodos de entrega
          await this.getCommunicationsMethodCredentialsOnDatabase()
          this.$notify({
            title: this.$t('project_detail.notify.delete_delivery_method'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },
    //* * Elimina un método de entrega */
    async removeCommunicationsMethods (communicationsMethods) {
      // Necesita el permiso PROJEC_DELIVERY_METHOD para poder eliminar elementos
      const idCommunicationMethod = this.currentRowProjectMethod.id
      if (this.canEditProjectDeliveryMethod) {
        const response = await this.getCommunicationsMethodCredentials({
          serviceId: this.serviceId,
          sender: 'ALL',
          idcommunication: idCommunicationMethod
        })
        // Si alguna empresa del servicio tiene el método de envío se avisa
        if (response && response.length > 0) {
          this.$confirm(this.$t('project_detail.title_delete_communication'), {
            confirmButtonText: this.$t('buttons.btnOk'),
            cancelButtonText: this.$t('buttons.btnCancel'),
            showCancelButton: true,
            center: true,
            iconClass: 'ods-icon-warning'
          }).then(async () => {
            this.deleteProjectMethod(idCommunicationMethod)
          }).catch(() => {})
        } else {
          this.deleteProjectMethod(idCommunicationMethod)
        }
      }
    },
    async deleteProjectMethod (idCommunicationMethod) {
      console.log('removeCommunicationsMethods: ', idCommunicationMethod)
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_delivery_method')
      })
      try {
        await this.removeCommunicationsMethod({
          serviceId: this.serviceId,
          communicationsmethodsId: idCommunicationMethod
        })
        // Cargamos en la tabla los metodos de entrega
        await this.getCommunicationsMethodsOnDatabase()
        // Cargamos en la tabla las credenciales por si cambian
        await this.getCommunicationsMethodCredentialsOnDatabase()
        // Cargamos el combo de metodos dentrega
        // await this.getFilterMethodsCommunications()
        // Cargamos Combo final métodos de comunicación
        this.getMethodsCommunications()
        this.$notify({
          title: this.$t('project_detail.notify.delete_delivery_method'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Elimina una validación
    async removeValidation (invoice) {
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_validation')
      })
      try {
        this.handleValidationCellMouseEnter(invoice)
        await this.removeProjectValidation({
          serviceId: this.serviceId,
          validationId: this.currentRowValidationsData.id
        })
        await this.getValidationsOnDatabase(true)
        this.$notify({
          title: this.$t('project_detail.notify.delete_validation'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Elimina una visualización PDF
    async removePDFVisualization () {
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.delete_PDFVisualization')
      })
      try {
        console.log(JSON.stringify(this.currentRowPDF))
        await this.removeProjectPDFVisualization({
          serviceId: this.serviceId,
          visualizationId: this.currentRowPDF.id
        })
        await this.getPDFVisualizationsOnDatabase()
        this.$notify({
          title: this.$t('project_detail.notify.delete_PDFVisualization'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 409:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 404:
          errorSms = 'global_error'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      try {
        error.data.message = errorSms
      } catch (error) {
        console.log('Error errorSms: ', errorSms)
      }
      this.showNotificationError(error)
    },
    async loadDataconfiguration () {
      // Get Datos de configuración
      if (this.dataconfigurationFlag) {
        this.dataconfigurationFlag = false
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          await this.getDataConfigurationOnDatabase()
          this.dataconfigurationMessage = true

          // Combo Datos de configuración
          await this.getOptionsFilterProjectConfiguration()
          // Tipo de configuración
          this.loadComboProjectConfigurationType()
        } finally {
          load.close()
        }
      }
    },
    async loadMimeconfiguration () {
      // Get Datos de configuración mime
      if (this.mimeconfigurationFlag) {
        this.mimeconfigurationFlag = false
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          await this.getMimeConfigurationOnDatabase()
          this.mimeconfigurationMessage = true
        } finally {
          load.close()
        }
      }
    },
    async loadProjectDeliveryNoteType () {
      // Get configuracion de tipos de albaranes
      this.optionsDeliveryNoteType = []
      this.optionsDeliveryNoteType = await this.getOptionsDeliveryNoteType()
      if (this.projectDeliveryNoteTypeFlag) {
        this.projectDeliveryNoteTypeFlag = false
        await this.getProjectDeliveryNoteTypeOnDatabase()
        this.projectDeliveryNoteTypeMessage = true
      }
    },
    async loadValidities () {
      // Get vigencias
      if (this.validitiesFlag) {
        this.validitiesFlag = false
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          await this.getvaliditiesOnDatabase()
          this.validitiesMessage = true

          // Cargamos tipos de documentos
          await this.chargeDialogAddValidity()
          // Roles de vigencia
          this.loadComboValidityRoleType()
        } finally {
          load.close()
        }
      }
    },
    async loadCommunicationsmethods () {
      // Get Metodos de entrega
      if (this.communicationsmethodsFlag) {
        this.communicationsmethodsFlag = false
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          await this.getCommunicationsMethodsOnDatabase()
          this.communicationsmethodsMessage = true
        } finally {
          load.close()
        }
      }
    },
    async loadCommunicationsmethodCredentials () {
      // Get Metodos de entrega
      if (this.communicationsmethodCredentialsFlag) {
        this.communicationsmethodCredentialsFlag = false
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          await this.getCommunicationsMethodCredentialsOnDatabase()
          this.communicationsmethodCredentialsMessage = true
        } finally {
          load.close()
        }
      }
    },
    async loadValidationsData () {
      // Get validaciones
      if (this.validationsDataFlag) {
        this.validationsDataFlag = false
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          await this.getValidationsOnDatabase(true)
          this.validationsDataMessage = true

          // Roles de validacion
          this.loadComboValidationRoleType()
        } finally {
          load.close()
        }
      }
    },
    async loadPendingtasksData () {
      // Get tareas pendientes
      if (this.pendingtasksDataFlag) {
        this.pendingtasksDataFlag = false
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          await this.getpendingTasksOnDatabase()
          this.pendingtasksDataMessage = true
        } finally {
          load.close()
        }
      }
    },
    async loadPdfData () {
      // Get DisplayDocuments
      if (this.pdfDataFlag) {
        this.pdfDataFlag = false
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          await this.getPDFVisualizationsOnDatabase()
          this.pdfDataMessage = true

          this.loadComboDirectioinPdfType()
          await this.getCommunicationsMethodsOnDatabase()
        } finally {
          load.close()
        }
      }
    },
    async loadRejectioncategoryData () {
      // Get categorías de rechazo
      if (this.rejectioncategoryDataFlag) {
        this.rejectioncategoryDataFlag = false
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          await this.getRejectionCategoriesOnDatabase()
          this.rejectioncategoryDataMessage = true
        } finally {
          load.close()
        }
      }
    },
    async loadEmailTypeData () {
      // Get EmailType
      if (this.emailTypeDataFlag) {
        this.emailTypeDataFlag = false
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          await this.getEmailTypeByProjectOnDatabase()
          this.emailTypeDataMessage = true
        } finally {
          load.close()
        }
      }
    },
    showDialogAddProjectDeliveryNoteType () {
      console.log('showDialogAddProjectDeliveryNoteType ')
      this.isShowDialogAddProjectDeliveryNoteType = true
    },
    showDialogProjectDocumentFormat () {
      console.log('showDialogProjectDocumentFormat ')
      this.isShowDialogProjectDocumentFormat = true
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })

    try {
      this.serviceId = this.$route.params.projectId
      // Get Info
      await this.getServiceOnDatabase()

      this.facturarOptions = [{ value: 'Editrack' }, { value: 'FacturaE' }]
      // por defecto Fenix
      if (!this.serviceDetailEditForm.facturar) {
        this.serviceDetailEditForm.facturar = 'FacturaE'
      }

      // Get Documentos y formatos emiten o reciben
      this.getProjectDocumentFormatOnDatabase()
      this.getProjectDocumentTypeOnDatabase()
    } catch (error) {
      console.log('Info: Inicializando datos created')
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-servicio {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body {
      padding: 32px;
      .info {
        padding-bottom: 32px;
      }
    }
  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }

  .collapse {
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table {
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row {
        .ods-button {
          padding: rem(0);
          margin-left: rem(0);
          margin-right: rem(0);
          i {
            margin-left: rem(0);
          }
        }
        .first-button {
          padding: rem(0);
          margin-left: rem(0);
          margin-right: rem(12);
          i {
            margin-left: rem(0);
          }
        }
      }
    }

    .button-collapse {
      float: right;
    }

    .button-collapse-withmargin {
      float: right;
      margin-top: 2rem;
    }

    ::v-deep .ods-module {
      &__body {
        padding: 0px;
      }
    }
  }

  .ods-tag + .ods-tag {
    margin-left: rem(10);
  }

  .botoneraLogo {
    padding-bottom: rem(0) !important;
    margin-left: rem(0);
  }
  .labelNameLogo {
    margin-top: 10px;
    vertical-align: middle;
    text-transform: initial !important;
    padding-bottom: rem(0) !important;
    margin-left: rem(10);
    display: inline-flex;
  }
  .ods-button.logoButtons {
    padding: 2px;
  }
  .ods-button + .ods-button {
    margin-left: rem(0) !important;
  }
  div.flexClass{
    display: inline-flex;
  }
  .ods-button.refresh {
    margin-left: 10px;
    margin-top: 18px;
  }
}
</style>
